import React, { Fragment, useMemo, useState, useEffect, useLayoutEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./KYC-Dashboard.css";
import KycStickyTopBar from "./KycStickyTopBar";
import {
	imgFilter,
	KYCAccountNameImage,
	KYCContactsImage,
	KYCCylindersImage,
	KYCDesignImage,
	KYCGroupCompanyImage,
	KYCMaterialsImage,
} from "../Elite/imageAssets";
import { Breadcrumb, Spin, Input, Card, Tabs, Select, DatePicker, Button, Modal } from "antd";
import {
	ArrowLeftOutlined,
	DownOutlined,
	EnvironmentFilled,
	EnvironmentOutlined,
	GlobalOutlined,
	LeftOutlined,
	LoadingOutlined,
	MinusOutlined,
	PlusOutlined,
	RightOutlined,
	SearchOutlined,
	UnorderedListOutlined,
} from "@ant-design/icons";
import { GoogleMap, InfoWindow, Marker, DirectionsRenderer, useJsApiLoader } from "@react-google-maps/api";
import addLocationIcon from "../../assets/images/add-location.svg";
import blackTickIcon from "../../assets/images/black-tick.svg";
import blueTickIcon from "../../assets/images/blue-tick.svg";
import yellowTickIcon from "../../assets/images/yellow-tick.svg";
import GreyTickIcon from "../../assets/images/grey-tick.svg";
import orangeTickIcon from "../../assets/images/orange-tick.svg";
import infoWindowChevronIcon from "../../assets/images/infowindow-chevron-double-right.svg";
import infoWindowLocationIcon from "../../assets/images/infowindow-location.svg";
import infoWindowLocationYellowIcon from "../../assets/images/infowindow-location-yellow.svg";
import infoWindowLocationOrangeIcon from "../../assets/images/infowindow-location-orange.svg";
import infoWindowMailIcon from "../../assets/images/infowindow-mail.svg";
import infoWindowPhoneIcon from "../../assets/images/infowindow-phone.svg";
import locationFromIcon from "../../assets/images/location-from.svg";
import locationSwapIcon from "../../assets/images/location-swap.svg";
import locationToIcon from "../../assets/images/location-to.svg";
import knackLogo from "../../assets/images/knackLogo.png";
import selectFromLocationIcon from "../../assets/images/select-from-location.svg";
import mapFullscreenEnterIcon from "../../assets/images/map-fullscreen-enter.svg";
import mapFullscreenExitIcon from "../../assets/images/map-fullscreen-exit.svg";
import { NotificationManager } from "react-notifications";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";
import KycService from "../../services/kyc-service";
import EliteCardService from "../../services/elite-cards-service";
import EmployeeFilterService from "../../services/employee-filter-service";
import KycGroupCompanyTab from "./KycGroupCompanyTab";
import KycAccountTab from "./KycAccountTab";
import KycMaterialsTab from "./KycMaterialsTab";
import KycQuotationTab from "./KycQuotationTab";
import KycOrdersTab from "./KycOrdersTab";
import KycDesignTab from "./KycDesignTab";
import KycMapPlaceInput from "./KycMapPlaceInput";
import {
	buildLocationFilter,
	extractLocation,
	filterMarkersNearRoute,
	getDirectionsPathCoordinates,
	getEncodedRoutePolyline,
	getPlaceGeometryLocation,
} from "./kycMapRouteUtils";
import useKycMapCompanyCluster from "./useKycMapCompanyCluster";
import { createKycTileLoadingMap, fetchKycSeparateTileCounts } from "./kycTileCountApi";
import KycTileSpin from "./KycTileSpin";
import {
	buildKycCompanyTabUrl,
	buildKycDashboardReturnLink,
	buildKycTableSearchUrl,
	buildKycTileCountsPayloadWithScope,
	KYC_TILE_COUNT_KEYS,
	getGroupCompanyId,
	getGroupCompanyName,
	getGroupCompanyRowLabel,
	KYC_GROUP_COMPANY_PARAM,
	KYC_MATERIALS_CUSTOMER_PARAM,
	KYC_COMPANY_TAB_LABELS,
	KYC_TABLE_SEARCH_PARAM,
	recordMatchesGroupCompanyScope,
	applyKycDesignationEmployeeFilters,
	getKycCompanyCode,
	saveKycGlobalFilterPayload,
	withKycCompanyCode,
	KYC_EMPTY_GLOBAL_FILTER_DATE,
} from "./kycHelpers";
import moment from "moment";

const { Search } = Input;
const { TabPane } = Tabs;
const { Option } = Select;
const getKycDropdownSuffixIcon = (isLoading) =>
	isLoading ? <LoadingOutlined spin /> : <DownOutlined />;

const DASHBOARD_TILE_KEYS = [
	KYC_TILE_COUNT_KEYS.groupCompany,
	KYC_TILE_COUNT_KEYS.company,
	KYC_TILE_COUNT_KEYS.contact,
	KYC_TILE_COUNT_KEYS.material,
	KYC_TILE_COUNT_KEYS.design,
	KYC_TILE_COUNT_KEYS.cylinder,
];

const defaultPayload = {
	fromDate: KYC_EMPTY_GLOBAL_FILTER_DATE,
	toDate: KYC_EMPTY_GLOBAL_FILTER_DATE,
	distributionChannel: "",
	priceGroup: "",
	salesDistrict: "",
	salesOffice: "",
	country: "",
	director: "",
	generalManager: "",
	continentalManager: "",
	regionalManager: "",
	areaManager: "",
	customerGroup: "",
	materialGroup: "",
	materialType: "",
	materialDivision: "",
	materialStructure: "",
	materialCharacteristics: "",
	materialHierarchy1: "",
	materialHierarchy2: "",
	materialHierarchy3: "",
};

const getFirstAvailableValue = (...values) =>
	values.find((value) => value !== undefined && value !== null && value !== "");
const defaultFilterValues = {
	fromDate: null,
	toDate: null,
	distributionChannel: [],
	priceGroup: [],
	salesDistrict: [],
	salesOffice: [],
	country: [],
	director: [],
	generalManager: [],
	continentalManager: [],
	regionalManager: [],
	areaManager: [],
	customerGroup: [],
	materialGroup: [],
	materialType: [],
	materialDivision: [],
	materialStructure: [],
	materialCharacteristics: [],
	materialHierarchy1: [],
	materialHierarchy2: [],
	materialHierarchy3: [],
};

const formatMultiSelectPayloadValue = (value) => {
	if (Array.isArray(value)) {
		return value.length ? value.join(",") : "";
	}
	return value || "";
};
const getFilterOptionList = (responseData, keys) => {
	for (const key of keys) {
		const value = responseData?.[key];
		if (Array.isArray(value)) {
			return value;
		}
	}

	return [];
};
const normalizeFilterOptions = (options = []) =>
	options
		.map((item, index) => {
			if (typeof item === "string" || typeof item === "number") {
				return { label: item, value: item, key: `${item}-${index}` };
			}

			if (!item || typeof item !== "object") {
				return null;
			}

			const value =
				item.value ??
				item.id ??
				item.sapCode ??
				item.code ??
				item.name ??
				item.label ??
				item.text ??
				item.title ??
				item.key;
			const label =
				item.label ??
				item.name ??
				item.text ??
				item.title ??
				item.value ??
				item.code ??
				item.sapCode ??
				item.id;

			if (value === undefined || label === undefined) {
				return null;
			}

			return {
				label,
				value,
				key: `${value}-${index}`,
			};
		})
		.filter(Boolean);

const toEmployeeSelectOptions = (items = []) =>
	(Array.isArray(items) ? items : [])
		.map((item, index) => {
			const value = item?.id ?? item?.employee_Sapcode ?? item?.value;
			const label =
				item?.value ??
				item?.name ??
				item?.label ??
				item?.employeeName ??
				item?.employee_Sapcode;
			if (value == null || label == null) {
				return null;
			}

			return {
				label: String(label),
				value: String(value),
				key: String(item?.id ?? `${value}-${index}`),
				sapCode:
					item?.employee_Sapcode != null && item?.employee_Sapcode !== ""
						? String(item.employee_Sapcode)
						: String(value),
			};
		})
		.filter(Boolean);

const mapSelectedEmployeeFilterValues = (selected, options = []) => {
	if (!Array.isArray(selected) || !selected.length) {
		return "";
	}

	const byValue = new Map(
		options.map((option) => [String(option.value), option.sapCode || option.value])
	);
	return selected.map((id) => byValue.get(String(id)) || id).join(",");
};

const normalizeDesignation = (designation) => String(designation || "").trim().toLowerCase();

const isDirectorDesignation = (designation) => normalizeDesignation(designation) === "director";

const isGeneralManagerDesignation = (designation) =>
	normalizeDesignation(designation) === "general manager";

const isContinentalHeadDesignation = (designation) => {
	const value = normalizeDesignation(designation);
	return value === "continantal head" || value === "continental head";
};

const isRegionalManagerDesignation = (designation) =>
	normalizeDesignation(designation) === "regional manager";

const isAreaManagerDesignation = (designation) =>
	normalizeDesignation(designation) === "area manager";

const getLockedEmployeeFilterField = (designation) => {
	if (isDirectorDesignation(designation)) return "director";
	if (isGeneralManagerDesignation(designation)) return "generalManager";
	if (isContinentalHeadDesignation(designation)) return "continentalManager";
	if (isRegionalManagerDesignation(designation)) return "regionalManager";
	if (isAreaManagerDesignation(designation)) return "areaManager";
	return null;
};

const isSalesHierarchyDesignation = (designation) =>
	isDirectorDesignation(designation) ||
	isGeneralManagerDesignation(designation) ||
	isContinentalHeadDesignation(designation) ||
	isRegionalManagerDesignation(designation) ||
	isAreaManagerDesignation(designation);

const isEmployeeFilterFieldLocked = (field, designation) => {
	if (field === "director") {
		return isSalesHierarchyDesignation(designation);
	}
	if (field === "generalManager") {
		return (
			isGeneralManagerDesignation(designation) ||
			isContinentalHeadDesignation(designation) ||
			isRegionalManagerDesignation(designation) ||
			isAreaManagerDesignation(designation)
		);
	}
	if (field === "continentalManager") {
		return (
			isContinentalHeadDesignation(designation) ||
			isRegionalManagerDesignation(designation) ||
			isAreaManagerDesignation(designation)
		);
	}
	if (field === "regionalManager") {
		return isRegionalManagerDesignation(designation) || isAreaManagerDesignation(designation);
	}
	if (field === "areaManager") {
		return isAreaManagerDesignation(designation);
	}
	return false;
};

const isEmployeeFilterDisabled = (field, designation, filterValues = {}) => {
	if (isEmployeeFilterFieldLocked(field, designation)) {
		return true;
	}
	if (field === "continentalManager") {
		return (
			!isEmployeeFilterFieldLocked("generalManager", designation) &&
			!filterValues.generalManager?.length
		);
	}
	if (field === "regionalManager") {
		return (
			!isEmployeeFilterFieldLocked("continentalManager", designation) &&
			!filterValues.continentalManager?.length
		);
	}
	if (field === "areaManager") {
		return (
			!isEmployeeFilterFieldLocked("regionalManager", designation) &&
			!filterValues.regionalManager?.length
		);
	}
	return false;
};

const getLoginDisplayName = (loginDetails) =>
	[loginDetails?.firstName, loginDetails?.lastName].filter(Boolean).join(" ").trim();

const matchLoginInOptions = (options = [], loginDetails) => {
	const loginOption = getLoginEmployeeOption(loginDetails);
	const name = getLoginDisplayName(loginDetails).toLowerCase();
	const sap = String(loginOption?.sapCode || "").trim().toLowerCase();
	const id = String(loginOption?.value || "").trim().toLowerCase();
	const email = String(loginDetails?.email || "").trim().toLowerCase();

	return (
		(Array.isArray(options) ? options : []).find((item) => {
			const value = String(item?.value ?? "").trim().toLowerCase();
			const label = String(item?.label ?? "").trim().toLowerCase();
			const itemSap = String(item?.sapCode ?? "").trim().toLowerCase();
			return (
				(id && (value === id || itemSap === id || label === id)) ||
				(sap && (value === sap || itemSap === sap || label === sap)) ||
				(name && (label === name || value === name)) ||
				(email && (value === email || label === email))
			);
		}) || null
	);
};

const getLoginEmployeeOption = (loginDetails) => {
	if (!loginDetails) {
		return null;
	}

	const sapCode =
		loginDetails.sapCode ??
		loginDetails.employee_Sapcode ??
		loginDetails.employeeSapCode ??
		loginDetails.hrmS_Code ??
		"";
	const id =
		loginDetails.id ??
		loginDetails.employeeId ??
		loginDetails.empId ??
		loginDetails.userId ??
		sapCode ??
		loginDetails.email;
	const label = getLoginDisplayName(loginDetails) || String(sapCode || id || "");
	if ((id == null || id === "") && !String(sapCode || "").trim() && !label) {
		return null;
	}

	const isDirector =
		String(loginDetails?.designation || "").trim().toLowerCase() === "director";
	const value =
		isDirector && String(sapCode || "").trim()
			? String(sapCode)
			: id != null && id !== ""
				? String(id)
				: String(sapCode || label);
	return {
		label,
		value,
		key: value,
		sapCode: String(sapCode || value),
	};
};

const withLockedEmployeeOption = (optionsByField, loginDetails) => {
	const option = getLoginEmployeeOption(loginDetails);
	const field = getLockedEmployeeFilterField(loginDetails?.designation);
	if (!option || !field) {
		return optionsByField;
	}

	const existing = optionsByField[field] || [];
	if (matchLoginInOptions(existing, loginDetails)) {
		return optionsByField;
	}

	const hasOption = existing.some((item) => String(item.value) === String(option.value));
	return {
		...optionsByField,
		[field]: hasOption ? existing : [option, ...existing],
	};
};

const getLockedEmployeeSelectedValue = (optionsByField, loginDetails) => {
	const option = getLoginEmployeeOption(loginDetails);
	const field = getLockedEmployeeFilterField(loginDetails?.designation);
	if (!option || !field) {
		return null;
	}

	const matched = matchLoginInOptions(optionsByField?.[field] || [], loginDetails);
	if (isDirectorDesignation(loginDetails?.designation) && option.sapCode) {
		return {
			field,
			value: String(option.sapCode),
		};
	}
	return {
		field,
		value: matched ? matched.value : option.value,
	};
};

const getDesignationDefaultFilterValues = (loginDetails) => {
	const next = { ...defaultFilterValues };
	const option = getLoginEmployeeOption(loginDetails);
	const field = getLockedEmployeeFilterField(loginDetails?.designation);
	if (option && field) {
		next[field] = [option.value];
	}
	return next;
};

const getEmployeeFilterPlaceholder = (field, fallbackPlaceholder, loginDetails) => {
	const name = getLoginDisplayName(loginDetails);
	if (!name) {
		return fallbackPlaceholder;
	}
	if (field === "director" && isDirectorDesignation(loginDetails?.designation)) {
		return name;
	}
	if (field === "generalManager" && isGeneralManagerDesignation(loginDetails?.designation)) {
		return name;
	}
	if (field === "continentalManager" && isContinentalHeadDesignation(loginDetails?.designation)) {
		return name;
	}
	if (field === "regionalManager" && isRegionalManagerDesignation(loginDetails?.designation)) {
		return name;
	}
	if (field === "areaManager" && isAreaManagerDesignation(loginDetails?.designation)) {
		return name;
	}
	return fallbackPlaceholder;
};

const getAccountRowCompanyName = (record = {}) => {
	for (const key of ["accountName", "companyName", "ispl_AccountName", "ispl_accountName"]) {
		const v = record[key];
		if (v !== undefined && v !== null && String(v).trim() !== "") {
			return String(v).trim();
		}
	}
	return "";
};

const VALID_COMPANY_NAV_TAB_KEYS = new Set([
	"groupCompany",
	"account",
	"materials",
	"quotation",
	"orders",
	"design",
]);

const readCompanyNavTabFromWindow = () => {
	if (typeof window === "undefined") {
		return "groupCompany";
	}
	const tab = new URLSearchParams(window.location.search).get("companyTab");
	return tab && VALID_COMPANY_NAV_TAB_KEYS.has(tab) ? tab : "groupCompany";
};

const readKycViewModeFromWindow = () => {
	if (typeof window === "undefined") {
		return "list";
	}
	return window.location.pathname === "/kyc/map" ? "map" : "list";
};

const KycDashboard = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams, setSearchParams] = useSearchParams();
	const loginDetails = useSelector(
		(state) => state.loginReducer.loginDetials.userDetails
	);
	const companyDetails = useSelector(
		(state) => state.CompanyDetails.companyDetials
	);
	const tileCountsRequestIdRef = useRef(0);
	const [tileLoading, setTileLoading] = useState(() =>
		createKycTileLoadingMap(DASHBOARD_TILE_KEYS, false)
	);
	const [activeCompanyTab, setActiveCompanyTab] = useState(readCompanyNavTabFromWindow);
	const [selectedGroupCompanyId, setSelectedGroupCompanyId] = useState("");
	const [selectedGroupCompanyName, setSelectedGroupCompanyName] = useState("");

	useEffect(() => {
		const tab = searchParams.get("companyTab");
		const resolved = tab && VALID_COMPANY_NAV_TAB_KEYS.has(tab) ? tab : "groupCompany";
		setActiveCompanyTab((prev) => (resolved !== prev ? resolved : prev));
	}, [searchParams]);

	useEffect(() => {
		const nextMode = location.pathname === "/kyc/map" ? "map" : "list";
		setKycViewMode((prev) => (prev !== nextMode ? nextMode : prev));
	}, [location.pathname]);

	const [groupCompanyTable, setGroupCompanyTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [accountTable, setAccountTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [materialsTable, setMaterialsTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [quotationTable, setQuotationTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [ordersTable, setOrdersTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [designTable, setDesignTable] = useState({
		rows: [],
		totalRecords: 0,
		currentPage: 1,
		pageSize: 10,
	});
	const [isGroupCompanyLoading, setIsGroupCompanyLoading] = useState(false);
	const [isAccountLoading, setIsAccountLoading] = useState(false);
	const [isMaterialsLoading, setIsMaterialsLoading] = useState(false);
	const [isQuotationLoading, setIsQuotationLoading] = useState(false);
	const [isOrdersLoading, setIsOrdersLoading] = useState(false);
	const [isDesignLoading, setIsDesignLoading] = useState(false);
	const [isFiltersLoading, setIsFiltersLoading] = useState(false);
	const [isFiltersExpanded, setIsFiltersExpanded] = useState(true);
	const [filterPanelHeight, setFilterPanelHeight] = useState(0);
	const [tableSearchValue, setTableSearchValue] = useState(() => {
		const initialSearch = searchParams.get(KYC_TABLE_SEARCH_PARAM);
		return initialSearch && String(initialSearch).trim() ? String(initialSearch).trim() : "";
	});
	const kycSearchFromUrl = searchParams.get(KYC_TABLE_SEARCH_PARAM) || "";
	const materialsCustomerFromUrl = searchParams.get(KYC_MATERIALS_CUSTOMER_PARAM) || "";
	const kycGroupCompanyFromUrl = searchParams.get(KYC_GROUP_COMPANY_PARAM) || "";
	const companyTabFromUrl = searchParams.get("companyTab") || "";
	const materialSearchFromUrl = companyTabFromUrl === "materials" ? kycSearchFromUrl : "";

	const resolveGroupCompanyNameFromNavigation = () => {
		const fromState = location.state?.groupCompanyName;
		if (fromState && String(fromState).trim()) {
			return String(fromState).trim();
		}
		if (kycGroupCompanyFromUrl.trim()) {
			return kycGroupCompanyFromUrl.trim();
		}
		return "";
	};

	useEffect(() => {
		const hasSearch = Boolean(kycSearchFromUrl.trim());
		const hasMaterialSearch = Boolean(materialSearchFromUrl.trim());
		const hasMaterialsCustomer = Boolean(materialsCustomerFromUrl.trim());
		const hasGroupCompanyInUrl = Boolean(kycGroupCompanyFromUrl.trim());

		if (hasSearch || hasMaterialsCustomer || hasGroupCompanyInUrl) {
			if (companyTabFromUrl === "materials") {
				setActiveCompanyTab("materials");
				setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));

				const groupIdFromState = location.state?.groupCompanyId;
				const groupNameFromState = location.state?.groupCompanyName;
				const accountFromState = location.state?.accountName;

				if (hasMaterialsCustomer) {
					const customer = materialsCustomerFromUrl.trim();
					setMaterialsIsplCustomer(customer);
					if (accountFromState && String(accountFromState).trim()) {
						setSelectedAccountName(String(accountFromState).trim());
					} else if (
						groupIdFromState ||
						groupNameFromState ||
						hasSearch
					) {
						setSelectedAccountName(customer);
					} else {
						setSelectedAccountName("");
					}
				} else {
					setMaterialsIsplCustomer("");
					setSelectedAccountName("");
				}

				if (groupIdFromState && String(groupIdFromState).trim()) {
					setSelectedGroupCompanyId(String(groupIdFromState).trim());
				} else {
					setSelectedGroupCompanyId("");
				}
				if (groupNameFromState && String(groupNameFromState).trim()) {
					setSelectedGroupCompanyName(String(groupNameFromState).trim());
				} else {
					setSelectedGroupCompanyName("");
				}
				setTableSearchValue(hasMaterialSearch ? materialSearchFromUrl.trim() : "");
			} else {
				setTableSearchValue(kycSearchFromUrl.trim());

				if (companyTabFromUrl === "account") {
					const groupIdFromState = location.state?.groupCompanyId;
					const groupNameFromNavigation = resolveGroupCompanyNameFromNavigation();
					const accountFromState = location.state?.accountName;

					if (groupIdFromState && String(groupIdFromState).trim()) {
						setSelectedGroupCompanyId(String(groupIdFromState).trim());
					}
					if (groupNameFromNavigation) {
						setSelectedGroupCompanyName(groupNameFromNavigation);
					}
					if (accountFromState && String(accountFromState).trim()) {
						setSelectedAccountName(String(accountFromState).trim());
					} else if (hasSearch) {
						setSelectedAccountName(kycSearchFromUrl.trim());
					} else {
						setSelectedAccountName("");
					}
					setMaterialsIsplCustomer("");
					setActiveCompanyTab("account");
					setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				} else {
					setSelectedGroupCompanyId("");
					setSelectedGroupCompanyName("");
					setSelectedAccountName("");
				}

				if (companyTabFromUrl === "account") {
					// handled above
				} else if (companyTabFromUrl === "design") {
					setActiveCompanyTab("design");
					setDesignTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				} else if (hasMaterialsCustomer) {
					setActiveCompanyTab("materials");
					setMaterialsIsplCustomer(materialsCustomerFromUrl.trim());
					setTableSearchValue("");
					setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				} else {
					setActiveCompanyTab("groupCompany");
					setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				}
			}

			setSearchParams(
				(prev) => {
					const next = new URLSearchParams(prev);
					next.delete(KYC_TABLE_SEARCH_PARAM);
					next.delete(KYC_MATERIALS_CUSTOMER_PARAM);
					next.delete(KYC_GROUP_COMPANY_PARAM);
					return next;
				},
				{ replace: true }
			);
			return;
		}

		const tableSearch = location.state?.tableSearch;
		if (tableSearch && String(tableSearch).trim()) {
			setTableSearchValue(String(tableSearch).trim());
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		const materialsCustomerFromState = location.state?.materialsCustomer;
		const hasMaterialsCustomerState =
			materialsCustomerFromState && String(materialsCustomerFromState).trim();

		if (hasMaterialsCustomerState) {
			const customer = String(materialsCustomerFromState).trim();
			setActiveCompanyTab("materials");
			setMaterialsIsplCustomer(customer);
			setTableSearchValue("");
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));

			const groupCompanyId = location.state?.groupCompanyId;
			const groupCompanyName = location.state?.groupCompanyName;
			if (groupCompanyId && String(groupCompanyId).trim()) {
				setSelectedGroupCompanyId(String(groupCompanyId).trim());
			}
			if (groupCompanyName && String(groupCompanyName).trim()) {
				setSelectedGroupCompanyName(String(groupCompanyName).trim());
			}
			const accountNameFromState = location.state?.accountName;
			if (accountNameFromState && String(accountNameFromState).trim()) {
				setSelectedAccountName(String(accountNameFromState).trim());
			} else if (hasMaterialsCustomerState && (groupCompanyId || groupCompanyName)) {
				setSelectedAccountName(customer);
			}
			return;
		}

		const returnTabFromState = location.state?.returnTab;
		const accountNameFromState = location.state?.accountName;
		const designMasterFromState = location.state?.designMasterNumber;
		const crmOrderNumberFromState = location.state?.crmOrderNumber;
		const materialNameFromState = location.state?.materialName;

		if (returnTabFromState === "materials") {
			const materialSearch =
				(materialNameFromState && String(materialNameFromState).trim()) ||
				(location.state?.tableSearch && String(location.state.tableSearch).trim()) ||
				"";
			setActiveCompanyTab("materials");
			if (materialSearch) {
				setTableSearchValue(materialSearch);
			}
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (returnTabFromState === "design") {
			const designSearch =
				(designMasterFromState && String(designMasterFromState).trim()) ||
				(location.state?.tableSearch && String(location.state.tableSearch).trim()) ||
				"";

			setActiveCompanyTab("design");
			setMaterialsIsplCustomer("");
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setSelectedAccountName("");
			if (designSearch) {
				setTableSearchValue(designSearch);
			}
			setDesignTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (returnTabFromState === "orders") {
			const orderSearch =
				(crmOrderNumberFromState && String(crmOrderNumberFromState).trim()) ||
				(location.state?.tableSearch && String(location.state.tableSearch).trim()) ||
				"";

			setActiveCompanyTab("orders");
			setMaterialsIsplCustomer("");
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setSelectedAccountName("");
			if (orderSearch) {
				setTableSearchValue(orderSearch);
			}
			setOrdersTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		const isAccountReturn =
			returnTabFromState === "account" ||
			(accountNameFromState && String(accountNameFromState).trim());

		if (isAccountReturn) {
			const accountName = accountNameFromState ? String(accountNameFromState).trim() : "";
			const groupId = location.state?.groupCompanyId;
			const groupName = resolveGroupCompanyNameFromNavigation();

			setActiveCompanyTab("account");
			setMaterialsIsplCustomer("");
			if (accountName) {
				setSelectedAccountName(accountName);
				setTableSearchValue(accountName);
			}
			if (groupId && String(groupId).trim()) {
				setSelectedGroupCompanyId(String(groupId).trim());
			}
			if (groupName) {
				setSelectedGroupCompanyName(groupName);
			}
			setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		const groupCompanyId = location.state?.groupCompanyId;
		const groupCompanyName = location.state?.groupCompanyName;
		const hasId = groupCompanyId && String(groupCompanyId).trim();
		const hasName = groupCompanyName && String(groupCompanyName).trim();

		if (!hasId && !hasName) {
			return;
		}

		setActiveCompanyTab("groupCompany");
		setMaterialsIsplCustomer("");
		setSelectedAccountName("");
		setTableSearchValue("");
		if (hasId) {
			setSelectedGroupCompanyId(String(groupCompanyId).trim());
		}
		if (hasName) {
			setSelectedGroupCompanyName(String(groupCompanyName).trim());
		}
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
	}, [
		kycSearchFromUrl,
		materialsCustomerFromUrl,
		kycGroupCompanyFromUrl,
		companyTabFromUrl,
		location.state?.tableSearch,
		location.state?.materialsCustomer,
		location.state?.accountName,
		location.state?.returnTab,
		location.state?.designMasterNumber,
		location.state?.groupCompanyId,
		location.state?.groupCompanyName,
		setSearchParams,
	]);

	const [kycViewMode, setKycViewMode] = useState(readKycViewModeFromWindow);
	const filterPanelContentRef = useRef(null);
	const [filterValues, setFilterValues] = useState(() =>
		getDesignationDefaultFilterValues(loginDetails)
	);
	const [filterOptions, setFilterOptions] = useState(() =>
		withLockedEmployeeOption(
			{
				distributionChannel: [],
				priceGroup: [],
				salesDistrict: [],
				salesOffice: [],
				country: [],
				director: [],
				generalManager: [],
				continentalManager: [],
				regionalManager: [],
				areaManager: [],
				customerGroup: [],
				materialGroup: [],
				materialType: [],
				materialDivision: [],
				materialStructure: [],
				materialCharacteristics: [],
				materialHierarchy1: [],
				materialHierarchy2: [],
				materialHierarchy3: [],
			},
			loginDetails
		)
	);
	const [managerFilterLoading, setManagerFilterLoading] = useState({
		generalManager: false,
		continentalManager: false,
		regionalManager: false,
		areaManager: false,
	});
	const [groupCompanySorter, setGroupCompanySorter] = useState({
		field: "CreatedOn",
		order: "DESC",
	});
	const [accountSorter, setAccountSorter] = useState({
		field: "CreatedOn",
		order: "DESC",
	});
	const [materialsSorter, setMaterialsSorter] = useState({
		field: "createdon",
		order: "DESC",
	});
	const [quotationSorter, setQuotationSorter] = useState({
		field: "createdOn",
		order: "DESC",
	});
	const [ordersSorter, setOrdersSorter] = useState({
		field: "createdOn",
		order: "DESC",
	});
	const [designSorter, setDesignSorter] = useState({
		field: "designMasterDate",
		order: "DESC",
	});
	const [materialsIsplCustomer, setMaterialsIsplCustomer] = useState("");
	const [selectedAccountName, setSelectedAccountName] = useState("");

	// --- Individual card count states (mirrors O2W pattern) ---
	const [groupCompanyCount, setGroupCompanyCount] = useState({});
	const [accountNameCount, setAccountNameCount] = useState({});
	const [contactsCount, setContactsCount] = useState({});
	const [materialsCount, setMaterialsCount] = useState({});
	const [designsCount, setDesignsCount] = useState({});
	const [cylindersCount, setCylindersCount] = useState({});

	const getCardTitle = (countObj, label, keys = ["total"]) => {
		const countValue = getFirstAvailableValue(...keys.map((key) => countObj?.[key]));
		return countValue !== undefined ? `${countValue} ${label}` : label;
	};

	const getCardCountValue = (countObj, keys) => {
		if (!countObj || Object.keys(countObj).length === 0) {
			return "-";
		}

		const countValue = getFirstAvailableValue(...keys.map((key) => countObj?.[key]));
		return countValue !== undefined ? countValue : "-";
	};

	const buildKycFilterPayload = () =>
		applyKycDesignationEmployeeFilters(
			{
				...defaultPayload,
				fromDate: filterValues.fromDate
					? moment(filterValues.fromDate).toISOString()
					: KYC_EMPTY_GLOBAL_FILTER_DATE,
				toDate: filterValues.toDate
					? moment(filterValues.toDate).toISOString()
					: KYC_EMPTY_GLOBAL_FILTER_DATE,
				distributionChannel: formatMultiSelectPayloadValue(filterValues.distributionChannel),
				priceGroup: formatMultiSelectPayloadValue(filterValues.priceGroup),
				salesDistrict: formatMultiSelectPayloadValue(filterValues.salesDistrict),
				salesOffice: formatMultiSelectPayloadValue(filterValues.salesOffice),
				country: formatMultiSelectPayloadValue(filterValues.country),
				director: isDirectorDesignation(loginDetails?.designation)
					? String(loginDetails?.sapCode || "").trim()
					: formatMultiSelectPayloadValue(filterValues.director),
				generalManager: mapSelectedEmployeeFilterValues(
					filterValues.generalManager,
					filterOptions.generalManager
				),
				continentalManager: mapSelectedEmployeeFilterValues(
					filterValues.continentalManager,
					filterOptions.continentalManager
				),
				regionalManager: mapSelectedEmployeeFilterValues(
					filterValues.regionalManager,
					filterOptions.regionalManager
				),
				areaManager: mapSelectedEmployeeFilterValues(
					filterValues.areaManager,
					filterOptions.areaManager
				),
				customerGroup: formatMultiSelectPayloadValue(filterValues.customerGroup),
				materialGroup: formatMultiSelectPayloadValue(filterValues.materialGroup),
				materialType: formatMultiSelectPayloadValue(filterValues.materialType),
				materialDivision: formatMultiSelectPayloadValue(filterValues.materialDivision),
				materialStructure: formatMultiSelectPayloadValue(filterValues.materialStructure),
				materialCharacteristics: formatMultiSelectPayloadValue(filterValues.materialCharacteristics),
				materialHierarchy1: formatMultiSelectPayloadValue(filterValues.materialHierarchy1),
				materialHierarchy2: formatMultiSelectPayloadValue(filterValues.materialHierarchy2),
				materialHierarchy3: formatMultiSelectPayloadValue(filterValues.materialHierarchy3),
				company_Code: getKycCompanyCode(companyDetails),
			},
			loginDetails
		);

	function buildKycTileCountsPayload() {
		return buildKycTileCountsPayloadWithScope(buildKycFilterPayload(), {
			groupCompanyId: selectedGroupCompanyId,
			isplCustomer: materialsIsplCustomer,
		});
	}

	const filterPayloadSignature = JSON.stringify(buildKycFilterPayload());

	useEffect(() => {
		handleGetKycGlobalFilters();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyDetails?.company_Code]);

	useEffect(() => {
		saveKycGlobalFilterPayload(buildKycFilterPayload());
		handleGetKycDashboardCount();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filterPayloadSignature, selectedGroupCompanyId, materialsIsplCustomer]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (activeCompanyTab === "groupCompany") {
				handleGetGroupCompanyList();
			}
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		groupCompanySorter.field,
		groupCompanySorter.order,
		groupCompanyTable.currentPage,
		selectedGroupCompanyId,
		selectedGroupCompanyName,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "account") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetAccountList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		selectedGroupCompanyId,
		filterPayloadSignature,
		tableSearchValue,
		accountSorter.field,
		accountSorter.order,
		accountTable.currentPage,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "materials") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetMaterialsList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		materialsSorter.field,
		materialsSorter.order,
		materialsTable.currentPage,
		materialsIsplCustomer,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "quotation") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetQuotationList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		quotationSorter.field,
		quotationSorter.order,
		quotationTable.currentPage,
		selectedGroupCompanyId,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "orders") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetOrdersList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		ordersSorter.field,
		ordersSorter.order,
		ordersTable.currentPage,
		selectedGroupCompanyId,
	]);

	useEffect(() => {
		if (activeCompanyTab !== "design") {
			return undefined;
		}

		const timeout = setTimeout(() => {
			handleGetDesignList();
		}, 500);

		return () => clearTimeout(timeout);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activeCompanyTab,
		filterPayloadSignature,
		tableSearchValue,
		designSorter.field,
		designSorter.order,
		designTable.currentPage,
		selectedGroupCompanyId,
	]);

	useLayoutEffect(() => {
		const contentNode = filterPanelContentRef.current;
		if (!contentNode) {
			return undefined;
		}

		const updateHeight = () => {
			setFilterPanelHeight(contentNode.scrollHeight);
		};
		const animationFrame = window.requestAnimationFrame(updateHeight);

		updateHeight();

		if (typeof ResizeObserver !== "undefined") {
			const resizeObserver = new ResizeObserver(() => {
				updateHeight();
			});
			resizeObserver.observe(contentNode);
			return () => {
				window.cancelAnimationFrame(animationFrame);
				resizeObserver.disconnect();
			};
		}

		window.addEventListener("resize", updateHeight);
		return () => {
			window.cancelAnimationFrame(animationFrame);
			window.removeEventListener("resize", updateHeight);
		};
	}, [isFiltersExpanded, isFiltersLoading, filterOptions, kycViewMode]);

	function buildGroupCompanyListPayload() {
		const payload = {
			pageindex: groupCompanyTable.currentPage,
			pagesize: groupCompanyTable.pageSize,
			sortcolumn: groupCompanySorter.field,
			orderBy: groupCompanySorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		if (selectedGroupCompanyName && !payload.search) {
			payload.search = selectedGroupCompanyName.trim();
		}

		return payload;
	}

	function buildAccountListPayload() {
		const payload = {
			pageindex: accountTable.currentPage,
			pagesize: accountTable.pageSize,
			sortcolumn: accountSorter.field,
			orderBy: accountSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		return payload;
	}

	function buildMaterialListPayload() {
		return {
			pageindex: materialsTable.currentPage,
			pagesize: materialsTable.pageSize,
			sortcolumn: materialsSorter.field,
			orderBy: materialsSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
			ispl_customer: materialsIsplCustomer ? materialsIsplCustomer.trim() : "",
		};
	}

	function buildDesignListPayload() {
		const payload = {
			pageindex: designTable.currentPage,
			pagesize: designTable.pageSize,
			sortcolumn: designSorter.field,
			orderBy: designSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
			materialName: "",
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		return payload;
	}

	function buildQuotationListPayload() {
		const payload = {
			pageindex: quotationTable.currentPage,
			pagesize: quotationTable.pageSize,
			sortcolumn: quotationSorter.field,
			orderBy: quotationSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		return payload;
	}

	function buildOrdersListPayload() {
		const payload = {
			pageindex: ordersTable.currentPage,
			pagesize: ordersTable.pageSize,
			sortcolumn: ordersSorter.field,
			orderBy: ordersSorter.order,
			search: tableSearchValue ? tableSearchValue.trim() : "",
			...buildKycFilterPayload(),
		};

		if (selectedGroupCompanyId) {
			payload.groupcomanyId = selectedGroupCompanyId;
		}

		return payload;
	}

	function setManagerOptions(field, items) {
		setFilterOptions((prev) => ({
			...prev,
			[field]: toEmployeeSelectOptions(items),
		}));
	}

	function fetchEmployeeManagerOptions(field, request, errorMessage) {
		setManagerFilterLoading((prev) => ({ ...prev, [field]: true }));
		return request()
			.then((response) => {
				const success =
					response.data?.statusCode === 200 || response.data?.status === true;
				const list = success ? response.data?.responseData : [];
				setManagerOptions(field, Array.isArray(list) ? list : []);
			})
			.catch((error) => {
				console.log(error, "Error");
				setManagerOptions(field, []);
				NotificationManager.error(errorMessage);
			})
			.finally(() => {
				setManagerFilterLoading((prev) => ({ ...prev, [field]: false }));
			});
	}

	function getEmployeeFilterPayload(ids) {
		return {
			id: Array.isArray(ids) && ids.length ? ids.toString() : "",
			email: loginDetails?.email || "",
		};
	}

	function loadGeneralManagers() {
		return fetchEmployeeManagerOptions(
			"generalManager",
			() => EmployeeFilterService.empGeneralManagerAPI(),
			"Unable to load general managers."
		);
	}

	function loadContinentalManagers(ids) {
		return fetchEmployeeManagerOptions(
			"continentalManager",
			() => EmployeeFilterService.empContinentalHeadAPI(getEmployeeFilterPayload(ids)),
			"Unable to load continental managers."
		);
	}

	function loadRegionalManagers(ids) {
		return fetchEmployeeManagerOptions(
			"regionalManager",
			() => EmployeeFilterService.empRegionalManagerAPI(getEmployeeFilterPayload(ids)),
			"Unable to load regional managers."
		);
	}

	function loadAreaManagers(ids) {
		return fetchEmployeeManagerOptions(
			"areaManager",
			() => EmployeeFilterService.empAreaManagerAPI(getEmployeeFilterPayload(ids)),
			"Unable to load area managers."
		);
	}

	function loadEmployeeFiltersByDesignation() {
		const designation = loginDetails?.designation;
		const lockedField = getLockedEmployeeFilterField(designation);
		const loginOption = getLoginEmployeeOption(loginDetails);

		setFilterOptions((prev) => {
			const next = {
				...prev,
				continentalManager: lockedField === "continentalManager" ? prev.continentalManager : [],
				regionalManager: lockedField === "regionalManager" ? prev.regionalManager : [],
				areaManager: lockedField === "areaManager" ? prev.areaManager : [],
			};
			return withLockedEmployeeOption(next, loginDetails);
		});

		if (lockedField && loginOption) {
			const selected = getLockedEmployeeSelectedValue(
				{ [lockedField]: [] },
				loginDetails
			);
			setFilterValues((prev) => ({
				...prev,
				[lockedField]: prev[lockedField]?.length
					? prev[lockedField]
					: [selected?.value || loginOption.value],
			}));
		}

		if (isGeneralManagerDesignation(designation)) {
			return loadContinentalManagers([]);
		}
		if (isContinentalHeadDesignation(designation)) {
			return loadRegionalManagers([]);
		}
		if (isRegionalManagerDesignation(designation)) {
			return loadAreaManagers([]);
		}
		if (isAreaManagerDesignation(designation)) {
			return Promise.resolve();
		}
		return loadGeneralManagers();
	}

	function handleGetKycGlobalFilters() {
		setIsFiltersLoading(true);
		KycService.getKycGlobalFiltersAPI({
			pageindex: 0,
			pagesize: 0,
			sortcolumn: "",
			orderBy: "",
			search: "",
			...buildKycFilterPayload(),
		})
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data?.responseData || response.data || {};
					const directorOptions = normalizeFilterOptions(
						getFilterOptionList(responseData, ["directors", "director"])
					);
					setFilterOptions((prev) => {
						const next = withLockedEmployeeOption(
							{
								...prev,
								distributionChannel: normalizeFilterOptions(
									getFilterOptionList(responseData, ["distributionChannels", "distributionChannel", "distChannels"])
								),
								priceGroup: normalizeFilterOptions(
									getFilterOptionList(responseData, ["priceGroups", "priceGroup"])
								),
								salesDistrict: normalizeFilterOptions(
									getFilterOptionList(responseData, ["salesDistricts", "salesDistrict"])
								),
								salesOffice: normalizeFilterOptions(
									getFilterOptionList(responseData, ["salesOffices", "salesOffice"])
								),
								country: normalizeFilterOptions(getFilterOptionList(responseData, ["countries", "country"])),
								director: directorOptions,
								customerGroup: normalizeFilterOptions(
									getFilterOptionList(responseData, ["customerGroups", "customerGroup"])
								),
								materialGroup: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialGroups", "materialGroup"])
								),
								materialType: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialTypes", "materialType"])
								),
								materialDivision: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialDivisions", "materialDivision"])
								),
								materialStructure: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialStructures", "materialStructure"])
								),
								materialCharacteristics: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialCharacteristics", "materialCharacteristic"])
								),
								materialHierarchy1: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialHierarchy1", "materialHierarchies1"])
								),
								materialHierarchy2: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialHierarchy2", "materialHierarchies2"])
								),
								materialHierarchy3: normalizeFilterOptions(
									getFilterOptionList(responseData, ["materialHierarchy3", "materialHierarchies3"])
								),
							},
							loginDetails
						);
						const selected = getLockedEmployeeSelectedValue(next, loginDetails);
						if (selected && isDirectorDesignation(loginDetails?.designation)) {
							setFilterValues((prevValues) => ({
								...prevValues,
								[selected.field]: [selected.value],
							}));
						}
						return next;
					});
				} else {
					NotificationManager.error(response.data?.message || "Unable to load KYC global filters.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load KYC global filters.");
			})
			.finally(() => {
				setIsFiltersLoading(false);
			});
		loadEmployeeFiltersByDesignation();
	}

	function handleGetGroupCompanyList() {
		setIsGroupCompanyLoading(true);
		const requestData = buildGroupCompanyListPayload();
		KycService.getKycGroupCompanyListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const groupCompanyList = Array.isArray(responseData)
						? responseData
						: responseData.kycGroupCompanyLists ||
						responseData.groupCompanyListing ||
						responseData.groupCompanyList ||
						responseData.data ||
						[];
					const scopedRows =
						selectedGroupCompanyId || selectedGroupCompanyName
							? groupCompanyList.filter((record) =>
								recordMatchesGroupCompanyScope(record, {
									groupCompanyId: selectedGroupCompanyId,
									groupCompanyName: selectedGroupCompanyName,
								})
							)
							: groupCompanyList;
					const totalRecords =
						selectedGroupCompanyId || selectedGroupCompanyName
							? scopedRows.length
							: Number(responseData.totalRecords || groupCompanyList.length || 0);
					const currentPage = Number(responseData.currentPage || groupCompanyTable.currentPage);

					setGroupCompanyTable((prev) => ({
						...prev,
						rows: scopedRows,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Group Company listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Group Company listing.");
			})
			.finally(() => {
				setIsGroupCompanyLoading(false);
			});
	}

	function handleGetAccountList() {
		setIsAccountLoading(true);
		const requestData = buildAccountListPayload();
		KycService.getKycCompanyListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const accountList = Array.isArray(responseData)
						? responseData
						: responseData.kycCompanyLists ||
						responseData.kycGroupCompanyLists ||
						responseData.companyListing ||
						responseData.companyList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || accountList.length || 0);
					const currentPage = Number(responseData.currentPage || accountTable.currentPage);

					setAccountTable((prev) => ({
						...prev,
						rows: accountList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Account listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Account listing.");
			})
			.finally(() => {
				setIsAccountLoading(false);
			});
	}

	function handleGetMaterialsList() {
		setIsMaterialsLoading(true);
		const requestData = buildMaterialListPayload();
		KycService.getKycMaterialMasterListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const materialList = Array.isArray(responseData)
						? responseData
						: responseData.kycMaterialMasterLists ||
						responseData.kycMaterialMasterList ||
						responseData.materialMasterList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || materialList.length || 0);
					const rawPage = responseData.currentPage;
					const parsedPage = Number(rawPage);
					const currentPage =
						rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
							? parsedPage
							: materialsTable.currentPage;

					setMaterialsTable((prev) => ({
						...prev,
						rows: materialList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Materials listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Materials listing.");
			})
			.finally(() => {
				setIsMaterialsLoading(false);
			});
	}

	function handleGetDesignList() {
		setIsDesignLoading(true);
		const requestData = buildDesignListPayload();
		KycService.getKycDesignMasterListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const designList = Array.isArray(responseData)
						? responseData
						: responseData.desingMasterLists ||
						responseData.kycDesignMasterLists ||
						responseData.designMasterList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || designList.length || 0);
					const rawPage = responseData.currentPage;
					const parsedPage = Number(rawPage);
					const currentPage =
						rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
							? parsedPage
							: designTable.currentPage;

					setDesignTable((prev) => ({
						...prev,
						rows: designList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Design listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Design listing.");
			})
			.finally(() => {
				setIsDesignLoading(false);
			});
	}

	function handleGetQuotationList() {
		setIsQuotationLoading(true);
		const requestData = buildQuotationListPayload();
		KycService.getKycQuotationMasterListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const quotationList = Array.isArray(responseData)
						? responseData
						: responseData.quotationMasterLists ||
						responseData.quotationMasterList ||
						responseData.kycQuotationMasterLists ||
						responseData.quotationList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || quotationList.length || 0);
					const rawPage = responseData.currentPage;
					const parsedPage = Number(rawPage);
					const currentPage =
						rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
							? parsedPage
							: quotationTable.currentPage;

					setQuotationTable((prev) => ({
						...prev,
						rows: quotationList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Quotation listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Quotation listing.");
			})
			.finally(() => {
				setIsQuotationLoading(false);
			});
	}

	function handleGetOrdersList() {
		setIsOrdersLoading(true);
		const requestData = buildOrdersListPayload();
		KycService.getKycOrderMasterListAPI(requestData)
			.then((response) => {
				const success = response.data?.statusCode === 200 || response.data?.status === true;
				if (success) {
					const responseData = response.data.responseData || {};
					const orderList = Array.isArray(responseData)
						? responseData
						: responseData.orderMasterLists ||
						responseData.orderMasterList ||
						responseData.kycOrderMasterLists ||
						responseData.orderList ||
						responseData.data ||
						[];
					const totalRecords = Number(responseData.totalRecords || orderList.length || 0);
					const rawPage = responseData.currentPage;
					const parsedPage = Number(rawPage);
					const currentPage =
						rawPage !== undefined && rawPage !== null && rawPage !== "" && !Number.isNaN(parsedPage)
							? parsedPage
							: ordersTable.currentPage;

					setOrdersTable((prev) => ({
						...prev,
						rows: orderList,
						totalRecords,
						currentPage,
					}));
				} else {
					NotificationManager.error(response.data?.message || "Unable to load Orders listing.");
				}
			})
			.catch((error) => {
				console.log(error, "Error");
				NotificationManager.error("Unable to load Orders listing.");
			})
			.finally(() => {
				setIsOrdersLoading(false);
			});
	}

	const handleTableSearchChange = (event) => {
		const value = event.target.value;
		setTableSearchValue(value);
		if (activeCompanyTab === "account") {
			setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		if (activeCompanyTab === "materials") {
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		if (activeCompanyTab === "quotation") {
			setQuotationTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		if (activeCompanyTab === "orders") {
			setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		if (activeCompanyTab === "design") {
			setDesignTable((prev) => ({ ...prev, currentPage: 1 }));
			return;
		}
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
	};

	const handleGroupCompanyTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setGroupCompanyTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setGroupCompanySorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleAccountTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setAccountTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setAccountSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleMaterialsTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setMaterialsTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setMaterialsSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleDesignTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setDesignTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setDesignSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleQuotationTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setQuotationTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setQuotationSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleOrdersTableChange = ({ currentPage, sortColumn, orderBy, pageSize }) => {
		setOrdersTable((prev) => ({
			...prev,
			currentPage,
			pageSize: pageSize || prev.pageSize,
		}));
		setOrdersSorter((prev) => ({
			field: sortColumn ?? prev.field,
			order: orderBy ?? prev.order,
		}));
	};

	const handleFilterValueChange = (field, value) => {
		if (isEmployeeFilterFieldLocked(field, loginDetails?.designation)) {
			return;
		}

		const nextValue = value ?? [];
		setFilterValues((prev) => {
			const next = { ...prev, [field]: nextValue };
			if (field === "generalManager") {
				next.continentalManager = [];
				next.regionalManager = [];
				next.areaManager = [];
			} else if (field === "continentalManager") {
				next.regionalManager = [];
				next.areaManager = [];
			} else if (field === "regionalManager") {
				next.areaManager = [];
			}
			return next;
		});

		if (field === "generalManager") {
			setFilterOptions((prev) => ({
				...prev,
				continentalManager: [],
				regionalManager: [],
				areaManager: [],
			}));
			if (nextValue.length) {
				loadContinentalManagers(nextValue);
			}
		} else if (field === "continentalManager") {
			setFilterOptions((prev) => ({
				...prev,
				regionalManager: [],
				areaManager: [],
			}));
			if (nextValue.length) {
				loadRegionalManagers(nextValue);
			}
		} else if (field === "regionalManager") {
			setFilterOptions((prev) => ({
				...prev,
				areaManager: [],
			}));
			if (nextValue.length) {
				loadAreaManagers(nextValue);
			}
		}

		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setQuotationTable((prev) => ({ ...prev, currentPage: 1 }));
		setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
		setDesignTable((prev) => ({ ...prev, currentPage: 1 }));
	};

	const handleResetFilters = () => {
		const nextOptions = withLockedEmployeeOption(
			{
				...filterOptions,
				continentalManager: [],
				regionalManager: [],
				areaManager: [],
			},
			loginDetails
		);
		const nextValues = getDesignationDefaultFilterValues(loginDetails);
		const selected = getLockedEmployeeSelectedValue(nextOptions, loginDetails);
		if (selected) {
			nextValues[selected.field] = [selected.value];
		}
		setFilterValues(nextValues);
		setFilterOptions(nextOptions);
		loadEmployeeFiltersByDesignation();
		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setQuotationTable((prev) => ({ ...prev, currentPage: 1 }));
		setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
		setDesignTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsIsplCustomer("");
		setSelectedAccountName("");
		setSelectedGroupCompanyId("");
		setSelectedGroupCompanyName("");
		setTableSearchValue("");
	};

	const persistCompanyNavTabToUrl = (key) => {
		setSearchParams(
			(prev) => {
				const next = new URLSearchParams(prev);
				if (key === "groupCompany") {
					next.delete("companyTab");
				} else {
					next.set("companyTab", key);
				}
				return next;
			},
			{ replace: true }
		);
	};

	const handleViewModeChange = (mode) => {
		const targetPath = mode === "map" ? "/kyc/map" : "/kyc";
		const currentSearch = searchParams.toString();

		setKycViewMode(mode);
		navigate(
			{
				pathname: targetPath,
				search: currentSearch ? `?${currentSearch}` : "",
			},
			{ replace: true }
		);
	};

	const handleOpenMaterialsForAccountCustomer = (record) => {
		const name = getAccountRowCompanyName(record);
		if (!name) {
			NotificationManager.warning("Company name is not available for this account.");
			return;
		}
		setMaterialsIsplCustomer(name);
		setSelectedAccountName(name);
		// Keep API filter by selected customer, but do not force-fill search input.
		setTableSearchValue("");
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setActiveCompanyTab("materials");
		persistCompanyNavTabToUrl("materials");
	};

	const handleCompanyTabChange = (key) => {
		if (activeCompanyTab === "materials" && key !== "materials") {
			setMaterialsIsplCustomer("");
			if (key !== "account") {
				setSelectedAccountName("");
			}
			setTableSearchValue("");
		}

		if (activeCompanyTab === "groupCompany" && key !== "groupCompany") {
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setTableSearchValue("");
		}

		if (activeCompanyTab === "account" && key !== "account") {
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setTableSearchValue("");
		}

		if (activeCompanyTab === "quotation" && key !== "quotation") {
			setTableSearchValue("");
		}

		if (activeCompanyTab === "orders" && key !== "orders") {
			setTableSearchValue("");
		}

		if (activeCompanyTab === "design" && key !== "design") {
			setTableSearchValue("");
		}

		setActiveCompanyTab(key);
		persistCompanyNavTabToUrl(key);

		if (key === "groupCompany") {
			setSelectedGroupCompanyId("");
			setSelectedGroupCompanyName("");
			setTableSearchValue("");
			setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (key === "account") {
			setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (key === "materials") {
			setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (key === "quotation") {
			setQuotationTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (key === "orders") {
			setOrdersTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		if (key === "design") {
			setDesignTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
			return;
		}

		setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1 }));
		setAccountTable((prev) => ({ ...prev, currentPage: 1 }));
		setMaterialsTable((prev) => ({ ...prev, currentPage: 1 }));
		setQuotationTable((prev) => ({ ...prev, currentPage: 1 }));
		setOrdersTable((prev) => ({ ...prev, currentPage: 1 }));
		setDesignTable((prev) => ({ ...prev, currentPage: 1 }));
	};

	const handleOpenAccountTab = (record) => {
		const nextGroupCompanyId = getGroupCompanyId(record);
		if (!nextGroupCompanyId) {
			return;
		}

		setMaterialsIsplCustomer("");
		setSelectedAccountName("");
		setSelectedGroupCompanyId(String(nextGroupCompanyId));
		setSelectedGroupCompanyName(getGroupCompanyRowLabel(record) || getGroupCompanyName(record));
		setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
		setActiveCompanyTab("account");
		persistCompanyNavTabToUrl("account");
	};

	function handleGetKycDashboardCount() {
		const requestId = tileCountsRequestIdRef.current + 1;
		tileCountsRequestIdRef.current = requestId;
		setTileLoading(createKycTileLoadingMap(DASHBOARD_TILE_KEYS, true));
		fetchKycSeparateTileCounts(
			buildKycTileCountsPayload(),
			DASHBOARD_TILE_KEYS,
			{},
			(tileKey, data) => {
				if (tileCountsRequestIdRef.current !== requestId) {
					return;
				}

				if (tileKey === KYC_TILE_COUNT_KEYS.groupCompany) {
					setGroupCompanyCount(data || {});
				} else if (tileKey === KYC_TILE_COUNT_KEYS.company) {
					setAccountNameCount(data || {});
				} else if (tileKey === KYC_TILE_COUNT_KEYS.contact) {
					setContactsCount(data || {});
				} else if (tileKey === KYC_TILE_COUNT_KEYS.material) {
					setMaterialsCount(data || {});
				} else if (tileKey === KYC_TILE_COUNT_KEYS.design) {
					setDesignsCount(data || {});
				} else if (tileKey === KYC_TILE_COUNT_KEYS.cylinder) {
					setCylindersCount(data || {});
				}

				setTileLoading((prev) => ({ ...prev, [tileKey]: false }));
			}
		).catch((error) => {
			if (tileCountsRequestIdRef.current !== requestId) {
				return;
			}
			console.log(error, "Error");
			setTileLoading(createKycTileLoadingMap(DASHBOARD_TILE_KEYS, false));
		});
	}

	const filterFieldConfigs = [
		{ key: "distributionChannel", placeholder: "Dist. Channel" },
		{ key: "priceGroup", placeholder: "Price Group" },
		{ key: "salesDistrict", placeholder: "Sales District" },
		{ key: "salesOffice", placeholder: "Sales Office" },
		{ key: "country", placeholder: "Country" },
		{ key: "director", placeholder: "Director" },
		{ key: "generalManager", placeholder: "General Manager" },
		{ key: "continentalManager", placeholder: "Continental Manager" },
		{ key: "regionalManager", placeholder: "Regional Manager" },
		{ key: "areaManager", placeholder: "Area Manager" },
		{ key: "customerGroup", placeholder: "Customer Group" },
		{ key: "materialGroup", placeholder: "Material Group" },
		{ key: "materialType", placeholder: "Material Type" },
		{ key: "materialDivision", placeholder: "Material Division Name" },
		{ key: "materialStructure", placeholder: "Material Structure Name" },
		{ key: "materialCharacteristics", placeholder: "Material Characteristics" },
		{ key: "materialHierarchy1", placeholder: "Material Hierarchy - 1" },
		{ key: "materialHierarchy2", placeholder: "Material Hierarchy - 2" },
		{ key: "materialHierarchy3", placeholder: "Material Hierarchy - 3" },
	];

	const activeTabLabel =
		kycViewMode === "map"
			? "Map"
			: KYC_COMPANY_TAB_LABELS[activeCompanyTab] || "Company Navigation";

	const kycBreadcrumbSegments = useMemo(() => {
		const segments = [];
		const search = tableSearchValue.trim();
		const groupName = selectedGroupCompanyName.trim();
		const materialsCustomer = materialsIsplCustomer.trim();
		const accountName = selectedAccountName.trim();

		if (groupName) {
			segments.push({
				key: `group-${groupName}`,
				label: groupName,
				to: buildKycTableSearchUrl(groupName),
				onNavigate: () => {
					setActiveCompanyTab("groupCompany");
					persistCompanyNavTabToUrl("groupCompany");
					setSelectedGroupCompanyId("");
					setSelectedGroupCompanyName(groupName);
					setMaterialsIsplCustomer("");
					setSelectedAccountName("");
					setTableSearchValue(groupName);
					setGroupCompanyTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				},
			});
		}

		if (
			accountName &&
			(accountName.toLowerCase() !== groupName.toLowerCase() || !groupName) &&
			(activeCompanyTab === "materials" || activeCompanyTab === "account")
		) {
			segments.push({
				key: `account-${accountName}`,
				label: accountName,
				to: buildKycDashboardReturnLink({
					returnTab: "account",
					groupCompanyId: selectedGroupCompanyId,
					groupCompanyName: groupName,
					accountName,
				}),
				onNavigate: () => {
					setActiveCompanyTab("account");
					persistCompanyNavTabToUrl("account");
					setMaterialsIsplCustomer("");
					setTableSearchValue(accountName);
					setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				},
			});
		}

		if (
			search &&
			(!groupName || search.toLowerCase() !== groupName.toLowerCase()) &&
			(!accountName || search.toLowerCase() !== accountName.toLowerCase())
		) {
			const searchTab =
				activeCompanyTab === "materials"
					? "materials"
					: activeCompanyTab === "account"
						? "account"
						: undefined;
			segments.push({
				key: `search-${search}`,
				label: search,
				to: buildKycTableSearchUrl(search, searchTab ? { companyTab: searchTab } : {}),
				onNavigate:
					searchTab === "materials"
						? () => {
							setActiveCompanyTab("materials");
							persistCompanyNavTabToUrl("materials");
							setTableSearchValue(search);
							setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
						}
						: searchTab === "account"
							? () => {
								setActiveCompanyTab("account");
								persistCompanyNavTabToUrl("account");
								setTableSearchValue(search);
								setMaterialsIsplCustomer("");
								setAccountTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
							}
							: undefined,
			});
		}

		if (
			activeCompanyTab === "materials" &&
			materialsCustomer &&
			!accountName &&
			materialsCustomer.toLowerCase() !== search.toLowerCase() &&
			materialsCustomer.toLowerCase() !== groupName.toLowerCase()
		) {
			segments.push({
				key: `materials-${materialsCustomer}`,
				label: materialsCustomer,
				to: buildKycDashboardReturnLink({
					returnTab: "materials",
					groupCompanyName: groupName,
					materialsCustomer,
				}),
				onNavigate: () => {
					setActiveCompanyTab("materials");
					persistCompanyNavTabToUrl("materials");
					setMaterialsIsplCustomer(materialsCustomer);
					setTableSearchValue("");
					setMaterialsTable((prev) => ({ ...prev, currentPage: 1, rows: [] }));
				},
			});
		}

		return segments;
	}, [
		activeCompanyTab,
		tableSearchValue,
		selectedGroupCompanyName,
		selectedGroupCompanyId,
		selectedAccountName,
		materialsIsplCustomer,
	]);

	const handleDashboardBreadcrumbClick = (event) => {
		event.preventDefault();
		handleResetFilters();
		setActiveCompanyTab("groupCompany");
		persistCompanyNavTabToUrl("groupCompany");
		navigate("/kyc", { replace: true });
	};

	const renderViewSwitch = () => (
		<div className="kyc-view-switch-wrap">
			<div className="kyc-view-switch" role="group" aria-label="KYC view">
				<button
					type="button"
					className={`kyc-view-switch-btn ${kycViewMode === "list" ? "active" : ""}`}
					onClick={() => handleViewModeChange("list")}>
					<UnorderedListOutlined />
					<span>List</span>
				</button>
				<button
					type="button"
					className={`kyc-view-switch-btn ${kycViewMode === "map" ? "active" : ""}`}
					onClick={() => handleViewModeChange("map")}>
					<EnvironmentOutlined />
					<span>Map</span>
				</button>
			</div>
		</div>
	);

	const renderKycBreadcrumbs = () => (
		<Breadcrumb className="details_breadcrum kyc-dashboard-breadcrumb" separator=">">
			<Breadcrumb.Item>
				<Link to="/kyc" onClick={handleDashboardBreadcrumbClick}>
					Dashboard
				</Link>
			</Breadcrumb.Item>
			{kycBreadcrumbSegments.map((segment) => (
				<Breadcrumb.Item key={segment.key}>
					{segment.onNavigate ? (
						<Link
							to={segment.to}
							onClick={(event) => {
								event.preventDefault();
								segment.onNavigate();
							}}
							onDoubleClick={(event) => {
								event.preventDefault();
							}}>
							<label>{segment.label}</label>
						</Link>
					) : (
						<Link to={segment.to}>
							<label>{segment.label}</label>
						</Link>
					)}
				</Breadcrumb.Item>
			))}
			{!(
				(activeCompanyTab === "groupCompany" && kycBreadcrumbSegments.length > 0) ||
				(activeCompanyTab === "account" && selectedAccountName.trim())
			) ? (
				<Breadcrumb.Item>
					<label>{activeTabLabel}</label>
				</Breadcrumb.Item>
			) : null}
		</Breadcrumb>
	);

	const showGroupCompanyTile = activeCompanyTab === "groupCompany";
	const showAccountTile =
		activeCompanyTab === "groupCompany" || activeCompanyTab === "account";

	const renderKycTopBar = () => (
		<KycStickyTopBar className="kyc-dashboard-top-bar details_view_title">
			<div className="kyc-dashboard-top-bar__left">
				<div className="kyc-dashboard-top-bar__breadcrumb">
					{renderKycBreadcrumbs()}
				</div>
			</div>
			{renderViewSwitch()}
		</KycStickyTopBar>
	);

	return (
		<Fragment>
			<div className="dashboard app-content content">
				<div className="content-wrapper">
					<div className="content-body">
						{kycViewMode === "map" ? (
							<KycMapView viewSwitch={renderViewSwitch()} />
						) : (
							<Fragment>
								{renderKycTopBar()}
								<div className="row">
										{/* Card 1 - Groups Company */}
										{showGroupCompanyTile ? (
											<div className="col-xl-4 col-lg-6 col-12">
												<div className="card kycbg_green">
													<KycTileSpin spinning={tileLoading.groupCompany}>
													<div className="card-content">
														<div className="kyc-card-body KYCGroupCompany images_bg">
															<div className="kyc-card-header">
																<div className="kyc-card-title">
																	<img src={KYCGroupCompanyImage} alt="Img" />
																	<span>
																		{getCardTitle(groupCompanyCount, "Groups Company", [
																			"totalCount",
																			"total",
																		])}
																	</span>
																</div>
															</div>
															<div className="kyc-card-stats">
																<div className="card_counts text-left">
																	<h5 className="text-white mb-2">
																		{Object.keys(groupCompanyCount).length > 0
																			? groupCompanyCount.withSAPCodeCount ||
																			groupCompanyCount.withSAPCode
																			: "-"}
																	</h5>
																	<h6 className="text-white mb-0">With SAP Code</h6>
																</div>
																<div className="kyc-border-right-white border-right-lighten-3"></div>
																<div className="card_counts text-left">
																	<h5 className="text-white mb-2">
																		{Object.keys(groupCompanyCount).length > 0
																			? groupCompanyCount.withoutSAPCodeCount ||
																			groupCompanyCount.withoutSAPCode
																			: "-"}
																	</h5>
																	<h6 className="text-white mb-0">Without SAP Code</h6>
																</div>
															</div>
														</div>
													</div>
													</KycTileSpin>
												</div>
											</div>
										) : null}

										{/* Card 2 - Account Name */}
										{showAccountTile ? (
											<div className="col-xl-4 col-lg-6 col-12">
												<div className="card kycbg_yellow">
													<KycTileSpin spinning={tileLoading.company}>
													<div className="card-content">
														<div className="kyc-card-body KYCAccountName images_bg">
															<div className="kyc-card-header">
																<div className="kyc-card-title">
																	<img src={KYCAccountNameImage} alt="Img" />
																	<span>
																		{getCardTitle(accountNameCount, "Account Name", [
																			"totalCount",
																			"total",
																		])}
																	</span>
																</div>
															</div>
															<div className="kyc-card-stats">
																<div className="card_counts text-left">
																	<h5 className="text-white mb-2">
																		{getCardCountValue(accountNameCount, [
																			"ship_To_Party",
																			"shipToParty",
																		])}
																	</h5>
																	<h6 className="text-white mb-0">Ship to Party</h6>
																</div>
																<div className="kyc-border-right-white border-right-lighten-3"></div>
																<div className="card_counts text-left">
																	<h5 className="text-white mb-2">
																		{getCardCountValue(accountNameCount, [
																			"bill_To_Party",
																			"billToParty",
																		])}
																	</h5>
																	<h6 className="text-white mb-0">Bill to Party</h6>
																</div>
																<div className="kyc-border-right-white border-right-lighten-3"></div>
																<div className="card_counts text-left">
																	<h5 className="text-white mb-2">
																		{getCardCountValue(accountNameCount, ["payer"])}
																	</h5>
																	<h6 className="text-white mb-0">Payer</h6>
																</div>
															</div>
														</div>
													</div>
													</KycTileSpin>
												</div>
											</div>
										) : null}

										{/* Card 3 - Contacts */}
										<div className="col-xl-4 col-lg-6 col-12">
											<div className="card kycbg_red">
												<KycTileSpin spinning={tileLoading.contact}>
												<div className="card-content">
													<div className="kyc-card-body KYCContacts images_bg">
														<div className="kyc-card-header">
															<div className="kyc-card-title">
																<img src={KYCContactsImage} alt="Img" />
																<span>
																	{getCardTitle(contactsCount, "Contacts", [
																		"totalCount",
																		"total",
																	])}
																</span>
															</div>
														</div>
														<div className="kyc-card-stats">
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(contactsCount, [
																		"activeCount",
																		"running",
																		"active",
																	])}
																</h5>
																<h6 className="text-white mb-0">Running</h6>
															</div>
															<div className="kyc-border-right-white border-right-lighten-3"></div>
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(contactsCount, [
																		"inactiveCount",
																		"hide",
																	])}
																</h5>
																<h6 className="text-white mb-0">Hide</h6>
															</div>
														</div>
													</div>
												</div>
												</KycTileSpin>
											</div>
										</div>

										{/* Card 4 - Materials */}
										<div className="col-xl-4 col-lg-6 col-12">
											<div className="card kycbg_blue">
												<KycTileSpin spinning={tileLoading.material}>
												<div className="card-content">
													<div className="kyc-card-body KYCMaterials images_bg">
														<div className="kyc-card-header">
															<div className="kyc-card-title">
																<img src={KYCMaterialsImage} alt="Img" />
																<span>
																	{getCardTitle(materialsCount, "Materials", [
																		"totalCount",
																		"total",
																	])}
																</span>
															</div>
														</div>
														<div className="kyc-card-stats">
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(materialsCount, [
																		"runningCount",
																		"running",
																	])}
																</h5>
																<h6 className="text-white mb-0">Running</h6>
															</div>
															<div className="kyc-border-right-white border-right-lighten-3"></div>
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(materialsCount, [
																		"hiddenCount",
																		"hide",
																	])}
																</h5>
																<h6 className="text-white mb-0">Hide</h6>
															</div>
														</div>
													</div>
												</div>
												</KycTileSpin>
											</div>
										</div>

										{/* Card 5 - Designs */}
										<div className="col-xl-4 col-lg-6 col-12">
											<div className="card kycbg_grey">
												<KycTileSpin spinning={tileLoading.design}>
												<div className="card-content">
													<div className="kyc-card-body KYCDesign images_bg">
														<div className="kyc-card-header">
															<div className="kyc-card-title">
																<img src={KYCDesignImage} alt="Img" />
																<span>
																	{getCardTitle(designsCount, "Designs", [
																		"totalCount",
																		"total",
																	])}
																</span>
															</div>
														</div>
														<div className="kyc-card-stats">
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(designsCount, [
																		"runningCount",
																		"running",
																	])}
																</h5>
																<h6 className="text-white mb-0">Running</h6>
															</div>
															<div className="kyc-border-right-white border-right-lighten-3"></div>
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(designsCount, [
																		"hiddenCount",
																		"hide",
																	])}
																</h5>
																<h6 className="text-white mb-0">Hide</h6>
															</div>
														</div>
													</div>
												</div>
												</KycTileSpin>
											</div>
										</div>

										{/* Card 6 - Cylinders */}
										<div className="col-xl-4 col-lg-6 col-12">
											<div className="card kycbg_purple">
												<KycTileSpin spinning={tileLoading.cylinder}>
												<div className="card-content">
													<div className="kyc-card-body KYCCylinders images_bg">
														<div className="kyc-card-header">
															<div className="kyc-card-title">
																<img src={KYCCylindersImage} alt="Img" />
																<span>
																	{getCardTitle(cylindersCount, "Cylinders", [
																		"totalCount",
																		"total",
																	])}
																</span>
															</div>
														</div>
														<div className="kyc-card-stats">
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(cylindersCount, [
																		"runningCount",
																		"running",
																	])}
																</h5>
																<h6 className="text-white mb-0">Running</h6>
															</div>
															<div className="kyc-border-right-white border-right-lighten-3"></div>
															<div className="card_counts text-left">
																<h5 className="text-white mb-2">
																	{getCardCountValue(cylindersCount, [
																		"hiddenCount",
																		"hide",
																		"close",
																	])}
																</h5>
																<h6 className="text-white mb-0">Close</h6>
															</div>
														</div>
													</div>
												</div>
												</KycTileSpin>
											</div>
										</div>
									</div>
								<Card className="kyc-filter-toggle-card" bodyStyle={{ padding: "0" }}>
									<button
										type="button"
										className={`kyc-filter-toggle-btn ${isFiltersExpanded ? "expanded" : "collapsed"}`}
										aria-expanded={isFiltersExpanded}
										onClick={() => setIsFiltersExpanded((prev) => !prev)}>
										<p>Global Filters</p>
										{isFiltersExpanded ? (
											<MinusOutlined className="kyc-filter-toggle-icon" />
										) : (
											<PlusOutlined className="kyc-filter-toggle-icon" />
										)}
									</button>
								</Card>
								<div
									className={`kyc-filter-panel-wrapper ${isFiltersExpanded ? "expanded" : "collapsed"}`}
									style={{ maxHeight: isFiltersExpanded ? `${filterPanelHeight}px` : "0px" }}>
									<div ref={filterPanelContentRef}>
										<Card className="kyc-filter-panel">
											<div className="kyc-filter-panel-header">
												<h5>Global Filters</h5>
												<Button
													type="link"
													className="kyc-filter-reset"
													onClick={handleResetFilters}>
													<span
														className="reset_filter_spn"
													>
														Reset filter
														<img src={imgFilter} alt="img" className="pb_5" />
													</span>
												</Button>
											</div>
											<Spin spinning={isFiltersLoading}>
												<div className="row drawer-content filter_dropdown drawer-select">
													<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom">
														<DatePicker
															placeholder="From Date"
															value={filterValues.fromDate}
															format="DD-MM-YYYY"
															onChange={(value) => handleFilterValueChange("fromDate", value)}
														/>
													</div>
													<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom">
														<DatePicker
															placeholder="To Date"
															value={filterValues.toDate}
															format="DD-MM-YYYY"
															onChange={(value) => handleFilterValueChange("toDate", value)}
														/>
													</div>
													{filterFieldConfigs.map((field) => (
														<div className="col-xl-3 col-lg-4 col-md-6 col-12 mb-20 col-xxl-5-custom" key={field.key}>
															<Select
																mode="multiple"
																allowClear={!isEmployeeFilterFieldLocked(field.key, loginDetails?.designation)}
																showSearch
																showArrow
																suffixIcon={getKycDropdownSuffixIcon(
																	Boolean(managerFilterLoading[field.key])
																)}
																optionFilterProp="children"
																placeholder={getEmployeeFilterPlaceholder(
																	field.key,
																	field.placeholder,
																	loginDetails
																)}
																loading={Boolean(managerFilterLoading[field.key])}
																disabled={isEmployeeFilterDisabled(
																	field.key,
																	loginDetails?.designation,
																	filterValues
																)}
																value={filterValues[field.key]}
																onChange={(value) => handleFilterValueChange(field.key, value)}>
																{(filterOptions[field.key] || []).map((option) => (
																	<Option key={option.key} value={option.value}>
																		{option.label}
																	</Option>
																))}
															</Select>
														</div>
													))}
												</div>
											</Spin>
										</Card>
									</div>
								</div>
								<div className="row dashboard_tabs material_tabs">
									<div className="col-12">
										<Card className="kyc-table-card">
											<div className="kyc-table-header">
												<h5 className="kyc-company-title">Company Navigation</h5>
												<div className="tab_searchtxt">
													<Search
														placeholder="Search..."
														className="dash_search"
														allowClear
														size="large"
														value={tableSearchValue}
														onChange={handleTableSearchChange}
														disabled={
															activeCompanyTab !== "groupCompany" &&
															activeCompanyTab !== "account" &&
															activeCompanyTab !== "materials" &&
															activeCompanyTab !== "quotation" &&
															activeCompanyTab !== "orders" &&
															activeCompanyTab !== "design"
														}
													/>
												</div>
											</div>
											<Tabs
												activeKey={activeCompanyTab}
												className="dash_tab_panel kyc_company_tabs"
												type="card"
												onChange={handleCompanyTabChange}>
												<TabPane tab="Group Company" key="groupCompany">
													<KycGroupCompanyTab
														tabTableData={groupCompanyTable}
														isLoading={isGroupCompanyLoading}
														tableSorter={groupCompanySorter}
														OnhandleTableSortColumn={handleGroupCompanyTableChange}
														selectedGroupCompanyId={selectedGroupCompanyId}
														onOpenAccountTab={handleOpenAccountTab}
													/>
												</TabPane>
												<TabPane tab="Account" key="account">
													<KycAccountTab
														navigationContext={{
															groupCompanyId: selectedGroupCompanyId,
															groupCompanyName: selectedGroupCompanyName,
															materialsIsplCustomer,
															activeCompanyTab,
														}}
														tabTableData={accountTable}
														isLoading={isAccountLoading}
														tableSorter={accountSorter}
														OnhandleTableSortColumn={handleAccountTableChange}
														onOpenMaterialsByCustomer={handleOpenMaterialsForAccountCustomer}
													/>
												</TabPane>
												<TabPane tab="Materials" key="materials">
													<KycMaterialsTab
														navigationContext={{
															groupCompanyId: selectedGroupCompanyId,
															groupCompanyName: selectedGroupCompanyName,
															materialsIsplCustomer,
															selectedAccountName,
															activeCompanyTab,
														}}
														tabTableData={materialsTable}
														isLoading={isMaterialsLoading}
														tableSorter={materialsSorter}
														OnhandleTableSortColumn={handleMaterialsTableChange}
													/>
												</TabPane>
												<TabPane tab="Quotation" key="quotation">
													<KycQuotationTab
														navigationContext={{
															groupCompanyId: selectedGroupCompanyId,
															groupCompanyName: selectedGroupCompanyName,
														}}
														tabTableData={quotationTable}
														isLoading={isQuotationLoading}
														tableSorter={quotationSorter}
														OnhandleTableSortColumn={handleQuotationTableChange}
													/>
												</TabPane>
												<TabPane tab="Orders" key="orders">
													<KycOrdersTab
														tabTableData={ordersTable}
														isLoading={isOrdersLoading}
														tableSorter={ordersSorter}
														OnhandleTableSortColumn={handleOrdersTableChange}
													/>
												</TabPane>
												<TabPane tab="Design" key="design">
													<KycDesignTab
														navigationContext={{
															groupCompanyId: selectedGroupCompanyId,
															groupCompanyName: selectedGroupCompanyName,
														}}
														tabTableData={designTable}
														isLoading={isDesignLoading}
														tableSorter={designSorter}
														OnhandleTableSortColumn={handleDesignTableChange}
													/>
												</TabPane>
											</Tabs>
										</Card>
									</div>
								</div>
							</Fragment>
						)}
					</div>
				</div>
			</div>
		</Fragment>
	);
};

const DEFAULT_MAP_CENTER = { lat: 22.9734, lng: 78.6569 };
const DEFAULT_MAP_ZOOM = 5;
const USER_LOCATION_AREA_ZOOM = 8;
const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const googleMapsLibraries = ["places", "geometry"];

const getUserGeoPosition = () =>
	new Promise((resolve, reject) => {
		if (!navigator.geolocation) {
			reject(new Error("Geolocation is not supported by this browser."));
			return;
		}

		navigator.geolocation.getCurrentPosition(resolve, reject, {
			enableHighAccuracy: true,
			timeout: 10000,
			maximumAge: 0,
		});
	});

const getViewportForUserLocation = (position) =>
	new Promise((resolve) => {
		if (!window.google?.maps?.Geocoder || !position) {
			resolve(null);
			return;
		}

		const geocoder = new window.google.maps.Geocoder();
		geocoder.geocode({ location: position }, (results, status) => {
			if (status !== "OK" || !Array.isArray(results) || !results.length) {
				resolve(null);
				return;
			}

			const preferred =
				results.find((item) => item.types?.includes("administrative_area_level_1")) ||
				results.find((item) => item.types?.includes("country")) ||
				results.find((item) => item.types?.includes("locality")) ||
				results[0];

			resolve(preferred?.geometry?.viewport || null);
		});
	});

const USER_LOCATION_BADGE_SIZE = 40;
let UserLocationOverlayClass = null;

const getUserLocationOverlayClass = () => {
	if (UserLocationOverlayClass || !window.google?.maps?.OverlayView) {
		return UserLocationOverlayClass;
	}

	UserLocationOverlayClass = class UserLocationOverlay extends window.google.maps.OverlayView {
		constructor(position) {
			super();
			this.position_ = new window.google.maps.LatLng(position.lat, position.lng);
			this.div = null;
		}

		onAdd() {
			const div = document.createElement("div");
			div.className = "kyc-map-user-location";
			div.title = "Your location";
			div.setAttribute("aria-label", "Your location");
			div.innerHTML = `
				<span class="kyc-map-user-location__ripple" aria-hidden="true"></span>
				<span class="kyc-map-user-location__ripple kyc-map-user-location__ripple--delay" aria-hidden="true"></span>
				<span class="kyc-map-user-location__badge" aria-hidden="true"></span>
			`;
			this.div = div;
			this.getPanes().overlayMouseTarget.appendChild(div);
		}

		draw() {
			if (!this.div) return;
			const projection = this.getProjection();
			if (!projection) return;
			const point = projection.fromLatLngToDivPixel(this.position_);
			if (!point) return;
			this.div.style.transform = `translate(${point.x - USER_LOCATION_BADGE_SIZE / 2}px, ${
				point.y - USER_LOCATION_BADGE_SIZE / 2
			}px)`;
		}

		onRemove() {
			if (this.div) {
				this.div.remove();
				this.div = null;
			}
		}
	};

	return UserLocationOverlayClass;
};

const ROUTE_THRESHOLD_KM = 25;
/**
 * Google Maps web /dir/ URL practical stop limit is ~10.
 * Extra stops are often dropped by Google even if more are sent.
 */
const GOOGLE_MAPS_MULTI_REDIRECT_LIMIT = 10;

const buildGoogleMapsMultiDirectionsUrl = (markers = []) => {
	const stops = (markers || [])
		.map((marker) => {
			const lat = Number(marker?.position?.lat);
			const lng = Number(marker?.position?.lng);
			if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
			return `${lat},${lng}`;
		})
		.filter(Boolean)
		.filter((stop, index, list) => index === 0 || stop !== list[index - 1])
		.slice(0, GOOGLE_MAPS_MULTI_REDIRECT_LIMIT);

	if (!stops.length) return "";

	// Path form paints Google Maps immediately; the waypoints query is slower to load.
	return `https://www.google.com/maps/dir/${stops.join("/")}`;
};

const openGoogleMapsDirections = (markers = []) => {
	const url = buildGoogleMapsMultiDirectionsUrl(markers);
	if (!url) {
		NotificationManager.warning("No valid map locations available to open in Google Maps.");
		return false;
	}
	window.open(url, "_blank", "noopener,noreferrer");
	return true;
};

const getMapMarkerAccountKey = (marker) => {
	if (!marker) return "";
	if (marker.type === "group") {
		return `group:${String(marker.groupCompanyId || marker.id || "").trim()}`;
	}
	return `company:${String(marker.companyId || marker.id || "").trim()}`;
};

const getFullscreenElement = () =>
	document.fullscreenElement ||
	document.webkitFullscreenElement ||
	document.msFullscreenElement ||
	null;

const isKycMapFullscreenElement = (panel, fullscreenEl) => {
	if (!panel || !fullscreenEl) return false;
	return fullscreenEl === panel || panel.contains(fullscreenEl) || fullscreenEl.contains(panel);
};

const KYC_MAP_INFO_PANEL_WIDTH = 408;

const clearKycMapBoxSize = (node) => {
	if (!node) return;
	node.style.removeProperty("width");
	node.style.removeProperty("height");
	node.style.removeProperty("min-width");
	node.style.removeProperty("min-height");
	node.style.removeProperty("max-width");
	node.style.removeProperty("max-height");
};

const setKycMapBoxSize = (node, width, height) => {
	if (!node) return;
	node.style.setProperty("width", width, "important");
	node.style.setProperty("height", height, "important");
	node.style.setProperty("min-height", height, "important");
	node.style.setProperty("max-height", "none", "important");
};

const setKycMapFullscreenMetrics = (enabled, panel, mapInstance, panelOpen = false) => {
	const viewportWidth = window.innerWidth;
	const viewportHeight = window.innerHeight;
	const layoutWidth = `${viewportWidth}px`;
	const layoutHeight = `${viewportHeight}px`;
	const mapWidth = `${Math.max(320, viewportWidth - (enabled && panelOpen ? KYC_MAP_INFO_PANEL_WIDTH : 0))}px`;
	const staticMap = panel?.querySelector?.(".kyc-static-map");
	const googleWrap = panel?.querySelector?.(".kyc-google-map");
	const mapDiv = mapInstance?.getDiv?.();
	const infoPanel = panel?.querySelector?.(".kyc-map-info");

	if (enabled && panel) {
		setKycMapBoxSize(panel, layoutWidth, layoutHeight);
		setKycMapBoxSize(staticMap, mapWidth, layoutHeight);
		setKycMapBoxSize(googleWrap, "100%", "100%");
		setKycMapBoxSize(mapDiv, "100%", "100%");
		if (panelOpen) {
			setKycMapBoxSize(infoPanel, `${KYC_MAP_INFO_PANEL_WIDTH}px`, layoutHeight);
			infoPanel?.style.setProperty("min-width", `${KYC_MAP_INFO_PANEL_WIDTH}px`, "important");
		} else {
			clearKycMapBoxSize(infoPanel);
		}
	} else {
		[panel, staticMap, googleWrap, mapDiv, infoPanel].forEach(clearKycMapBoxSize);
	}

	document.documentElement.classList.toggle("kyc-map-fs", Boolean(enabled));

	if (mapInstance) {
		const center = mapInstance.getCenter();
		const zoom = mapInstance.getZoom();
		window.google?.maps?.event?.trigger(mapInstance, "resize");
		if (center) mapInstance.setCenter(center);
		if (zoom != null) mapInstance.setZoom(zoom);
	}
};

const getGoogleMapOptions = () => {
	const position = window.google?.maps?.ControlPosition?.RIGHT_BOTTOM;

	return {
		disableDefaultUI: true,
		zoomControl: true,
		zoomControlOptions: position ? { position } : undefined,
		mapTypeControl: false,
		streetViewControl: false,
		fullscreenControl: false,
		clickableIcons: false,
		keyboardShortcuts: false,
		gestureHandling: "cooperative",
	};
};

const markerIconConfig = {
	group: { url: yellowTickIcon, width: 35, height: 36, tipY: 30.5 },
	company: { url: blueTickIcon, width: 35, height: 36, tipY: 30.5 },
	prospect: { url: GreyTickIcon, width: 35, height: 36, tipY: 30.5 },
	other: { url: orangeTickIcon, width: 35, height: 36, tipY: 30.5 },
	selected: { url: blackTickIcon, width: 46, height: 53, tipY: 45.5 },
};

const normalizeMapMarkerType = (rawType) => {
	const normalized = String(rawType || "")
		.trim()
		.toLowerCase()
		.replace(/[\s_-]+/g, "");

	if (normalized === "prospect") {
		return "prospect";
	}

	if (normalized === "groupcompany" || normalized.includes("group")) {
		return "group";
	}

	if (normalized === "other" || normalized === "others") {
		return "other";
	}

	if (
		normalized === "customer" ||
		normalized === "company" ||
		normalized === "account"
	) {
		return "company";
	}

	// Unclassified locations use the Others pin.
	return "other";
};

const getMapMarkerTypeLabel = (type) => {
	if (type === "group") return "Group Company";
	if (type === "prospect") return "Prospect";
	if (type === "other") return "Others";
	return "Customer";
};

const EMPTY_MAP_LOCATION_COUNTS = {
	totalCount: 0,
	groupCompanyCount: 0,
	customerCount: 0,
	prospectCount: 0,
	otherCount: 0,
};

const formatMapLegendCount = (value) => Number(value || 0).toLocaleString();

const KycMapLegendCountBadge = ({ count, className }) => (
	<em className={className}>{formatMapLegendCount(count)}</em>
);

const getMapLocationCounts = (response) => {
	const payload = response?.data;
	const responseData = payload?.responseData ?? payload;
	const raw =
		responseData && !Array.isArray(responseData) ? responseData.locationCounts : null;
	if (!raw || typeof raw !== "object") {
		return null;
	}

	return {
		totalCount: Number(raw.totalCount) || 0,
		groupCompanyCount: Number(raw.groupCompanyCount) || 0,
		customerCount: Number(raw.customerCount) || 0,
		prospectCount: Number(raw.prospectCount) || 0,
		otherCount: Number(raw.otherCount) || 0,
	};
};

const countMapMarkersByType = (markers = []) =>
	(markers || []).reduce(
		(counts, marker) => {
			if (marker?.type === "group") {
				counts.groupCompanyCount += 1;
			} else if (marker?.type === "prospect") {
				counts.prospectCount += 1;
			} else if (marker?.type === "other") {
				counts.otherCount += 1;
			} else {
				counts.customerCount += 1;
			}
			counts.totalCount += 1;
			return counts;
		},
		{ ...EMPTY_MAP_LOCATION_COUNTS }
	);

const resolveMapLocationCounts = (response, markers = []) =>
	getMapLocationCounts(response) || countMapMarkersByType(markers);

const KycMapLegend = ({
	showCounts = false,
	locationCounts = EMPTY_MAP_LOCATION_COUNTS,
}) => {
	return (
		<div className="kyc-map-legend" aria-label="Map pin legend">
			<span>
				<img src={yellowTickIcon} alt="" />
				Group Company
				{showCounts ? (
					<KycMapLegendCountBadge
						count={locationCounts.groupCompanyCount}
						className="kyc-map-legend__count is-group"
					/>
				) : null}
			</span>
			<span>
				<img src={blueTickIcon} alt="" />
				Customer
				{showCounts ? (
					<KycMapLegendCountBadge
						count={locationCounts.customerCount}
						className="kyc-map-legend__count is-customer"
					/>
				) : null}
			</span>
			<span>
				<img src={GreyTickIcon} alt="" />
				Prospect
				{showCounts ? (
					<KycMapLegendCountBadge
						count={locationCounts.prospectCount}
						className="kyc-map-legend__count is-prospect"
					/>
				) : null}
			</span>
			<span>
				<img src={orangeTickIcon} alt="" />
				Others
				{showCounts ? (
					<KycMapLegendCountBadge
						count={locationCounts.otherCount}
						className="kyc-map-legend__count is-other"
					/>
				) : null}
			</span>
		</div>
	);
};

const getMapMarkerInfoIcon = (type) => {
	if (type === "group") return infoWindowLocationYellowIcon;
	if (type === "prospect") return GreyTickIcon;
	if (type === "other") return infoWindowLocationOrangeIcon;
	return infoWindowLocationIcon;
};

const getGoogleMarkerIcon = (type) => {
	const config = markerIconConfig[type] || markerIconConfig.company;
	if (!window.google?.maps) {
		return { url: config.url };
	}

	return {
		url: config.url,
		scaledSize: new window.google.maps.Size(config.width, config.height),
		anchor: new window.google.maps.Point(config.width / 2, config.tipY),
	};
};

const getMapResponseList = (response) => {
	const payload = response?.data;
	const success = payload?.statusCode === 200 || payload?.status === true;
	if (!success) {
		return [];
	}

	const responseData = payload?.responseData ?? payload;
	if (Array.isArray(responseData)) {
		return responseData;
	}

	if (responseData && typeof responseData === "object") {
		const nestedList =
			responseData.companyLocationLists ||
			responseData.companyLocations ||
			responseData.companyLocationList ||
			responseData.relationTypes ||
			responseData.relationTypeList ||
			responseData.locations ||
			responseData.list ||
			responseData.data;
		return Array.isArray(nestedList) ? nestedList : [];
	}

	return [];
};

const toMapCoordinate = (value) => {
	const numeric = Number(value);
	return Number.isFinite(numeric) ? numeric : null;
};

const toMapLatLng = (latitude, longitude) => {
	if (Math.abs(latitude) > 90 && Math.abs(longitude) <= 90) {
		return { lat: longitude, lng: latitude };
	}
	if (Math.abs(latitude) > 40 && Math.abs(longitude) <= 40) {
		return { lat: longitude, lng: latitude };
	}
	return { lat: latitude, lng: longitude };
};

const buildMapMarkerAddress = (item = {}) => {
	const lineAddress = [item?.address1_Line1, item?.address1_Line2]
		.filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
		.join(", ");
	const regionAddress = [item?.ispl_City, item?.ispl_State, item?.ispl_Country]
		.filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
		.join(", ");

	return (
		getFirstAvailableValue(
			lineAddress,
			item?.formattedAddress,
			item?.companyAddress,
			item?.fullAddress,
			item?.address,
			regionAddress,
			item?.location,
			""
		) || ""
	);
};

const toMapMarkers = (items = []) =>
	items
		.map((item, index) => {
			const latitude = toMapCoordinate(item?.latitude);
			const longitude = toMapCoordinate(item?.longitude);
			if (latitude == null || longitude == null) {
				return null;
			}

			const markerType = normalizeMapMarkerType(item?.type);
			const isGroup = markerType === "group";
			const markerId = isGroup
				? `group-${item.groupCompanyId || index}`
				: markerType === "prospect"
					? `prospect-${item.companyId || item.prospectId || index}`
					: markerType === "other"
						? `other-${item.companyId || item.otherId || index}`
						: `company-${item.companyId || index}`;
			const title =
				getFirstAvailableValue(
					item?.companyName,
					item?.groupCompanyName,
					item?.accountName,
					item?.name,
					item?.location,
					"Location"
				) || "Location";
			const phone =
				getFirstAvailableValue(
					item?.mobilePhone,
					item?.mobileNo,
					item?.mobileNumber,
					item?.mobile,
					item?.contactNumber,
					item?.contactNo,
					item?.phoneNumber,
					item?.phone,
					""
				) || "";
			const email =
				getFirstAvailableValue(
					item?.email,
					item?.emailId,
					item?.emailAddress,
					item?.companyEmail,
					item?.primaryEmail,
					""
				) || "";

			return {
				id: markerId,
				type: markerType,
				companyId: item?.companyId ?? item?.company_Id ?? item?.cG_Id ?? "",
				groupCompanyId:
					item?.groupCompanyId ??
					item?.groupCompany_Id ??
					item?.customer_Organisation ??
					"",
				position: toMapLatLng(latitude, longitude),
				title: String(title),
				address: String(buildMapMarkerAddress(item)),
				phone: String(phone),
				email: String(email),
				primaryContactName: String(
					getFirstAvailableValue(item?.primaryContactName, item?.contactName, "") || ""
				),
				sapCode: String(
					getFirstAvailableValue(item?.sapCode, item?.ispl_SAPCode, item?.SAPCode, "") || ""
				),
				accountCode: String(
					getFirstAvailableValue(
						item?.accountCode,
						item?.ispl_AccountCode,
						item?.account_Code,
						""
					) || ""
				),
				raw: item,
			};
		})
		.filter(Boolean);

const getYearlyInvoiceSummaryData = (response) => {
	const payload = response?.data;
	const success = payload?.statusCode === 200 || payload?.status === true;
	if (!success) return null;

	const responseData = payload?.responseData ?? payload?.data ?? payload;
	if (!responseData || typeof responseData !== "object") return null;
	if (Array.isArray(responseData)) return responseData[0] || null;
	return responseData;
};

const formatSummaryNumber = (value, { decimals, suffix = "" } = {}) => {
	if (value === undefined || value === null || value === "") {
		value = 0;
	}
	const numeric = Number(value);
	if (!Number.isFinite(numeric)) return String(value);

	const fractionDigits =
		typeof decimals === "number" ? decimals : Number.isInteger(numeric) ? 0 : 3;
	const formatted = numeric.toLocaleString("en-IN", {
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	});
	const unit = String(suffix || "").trim();
	return unit ? `${formatted} ${unit}` : formatted;
};

const getSummaryWeightUnit = (summary = {}) =>
	String(summary.base_Unit || summary.baseUnit || "").trim().toLowerCase();

const getSummaryCurrency = (summary = {}) =>
	String(summary.currency || "").trim();

const buildContactAddress = (contact) => {
	if (!contact || typeof contact !== "object") return "";

	return [contact.address1_Line1, contact.address1_Line2, contact.ispl_City, contact.ispl_State, contact.ispl_Country]
		.filter((value) => value !== undefined && value !== null && String(value).trim() !== "")
		.join(", ");
};

const formatOptionalSummaryNumber = (value, options = {}) =>
	formatSummaryNumber(value, options);

const formatOutstandingAmount = (value) => {
	if (value === undefined || value === null || value === "") return "—";
	if (typeof value === "string") return value;
	return formatSummaryNumber(value, { decimals: 2 });
};

const buildTotalSummaryRows = (summary = {}) => [
	{ label: "Invoice:", value: formatSummaryNumber(summary.invoice_Count) },
	{ label: "Material:", value: formatSummaryNumber(summary.material_Count) },
	{
		label: "Total Num of Bags:",
		value: formatSummaryNumber(summary.total_Dispatch_Qty),
	},
	{
		label: "Basic Value:",
		value: formatSummaryNumber(summary.total_Net_Amount, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{
		label: "Total wt of Bag:",
		value: formatSummaryNumber(summary.total_weight_bag, {
			suffix: "kg",
		}),
	},
	{
		label: "Avg wt per Bag:",
		value: formatSummaryNumber(summary.avg_weight_bag, {
			suffix: "g",
		}),
	},
	{
		label: "Avg rate per Bag:",
		value: formatSummaryNumber(summary.avgRatePerPic, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{
		label: "Avg rate per KG:",
		value: formatSummaryNumber(summary.avgRatePerKg, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{ label: "Cylinders:", value: formatSummaryNumber(summary.cylinder) },
	{
		label: "Material Group:",
		value: formatSummaryNumber(summary.material_Group_Count ?? summary.material_group_Count),
	},
];

/** Group accountInfo records with their yearly accountSummery rows. */
const getGroupedAccountInfo = (accountInfo = []) => {
	if (!Array.isArray(accountInfo)) return [];

	return accountInfo.map((account, accountIndex) => {
		const summaries = Array.isArray(account?.accountSummery) ? account.accountSummery : [];
		const seenYears = new Set();
		const yearSummaries = [];

		summaries.forEach((summary, summaryIndex) => {
			const yearKey =
				summary?.invoice_Year ?? summary?.invoice_Year_Range ?? `idx-${summaryIndex}`;
			if (seenYears.has(yearKey)) return;
			seenYears.add(yearKey);
			yearSummaries.push({
				key: [
					account?.sold_Account_Customer_SAP_Code || accountIndex,
					yearKey,
					summaryIndex,
				].join("-"),
				...summary,
			});
		});

		return {
			key: String(
				account?.sold_Account_Customer_SAP_Code ||
				account?.customer_Name ||
				accountIndex
			),
			customerName: account?.customer_Name || "Account",
			sapCode: account?.sold_Account_Customer_SAP_Code || "",
			address: buildContactAddress(account),
			phone: account?.mobilePhone || "",
			email: account?.email || "",
			primaryContactName: account?.primaryContactName || "",
			yearSummaries,
		};
	});
};

const getSoldAccountSapCodes = (summary) => {
	const accounts = Array.isArray(summary?.accountInfo) ? summary.accountInfo : [];
	return [
		...new Set(
			accounts
				.map((account) =>
					String(account?.sold_Account_Customer_SAP_Code || "").trim()
				)
				.filter(Boolean)
		),
	].join(",");
};

const buildAccountYearCardFields = (summary = {}) => [
	{
		label: "Particular:",
		value: summary.invoice_Year_Range || "NA",
	},
	{
		label: "Invoice:",
		value: formatOptionalSummaryNumber(summary.invoice_Count),
	},
	{
		label: "Total Num of Bags:",
		value: formatOptionalSummaryNumber(summary.total_Dispatch_Qty),
	},
	{
		label: "Material:",
		value: formatOptionalSummaryNumber(summary.material_Count),
	},
	{
		label: "Basic Value:",
		value: formatOptionalSummaryNumber(summary.total_Net_Amount, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{
		label: "Total Weight of Bag:",
		value: formatOptionalSummaryNumber(summary.total_weight_bag, {
			suffix: getSummaryWeightUnit(summary),
		}),
	},
	{
		label: "Avg wt per Bag:",
		value: formatOptionalSummaryNumber(summary.avg_weight_bag, {
			suffix: "g",
		}),
	},
	{
		label: "Avg rate per Bag:",
		value: formatOptionalSummaryNumber(summary.avgRatePerPic, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{
		label: "Avg rate per Kg:",
		value: formatOptionalSummaryNumber(summary.avgRatePerKg, {
			suffix: getSummaryCurrency(summary),
		}),
	},
	{
		label: "Cylinders:",
		value: formatOptionalSummaryNumber(summary.cylinder),
	},
	{
		label: "Material Group:",
		value: formatOptionalSummaryNumber(
			summary.material_group_Count ?? summary.material_Group_Count
		),
		fullWidth: true,
	},
];

const toMapSelectOptions = (items = []) =>
	items
		.map((item) => {
			const label =
				item?.name ||
				item?.formattedAddress ||
				item?.address ||
				item?.location ||
				item?.relationType ||
				item?.relationTypeName ||
				item?.type ||
				item?.districtCity ||
				item?.state ||
				item?.country;
			const value = item?.id ?? item?.value ?? item?.code ?? label;

			return value != null && label
				? { value: String(value), label: String(label) }
				: null;
		})
		.filter(Boolean);

const serializeMapFilterValue = (value) =>
	(Array.isArray(value) ? value : value ? [value] : [])
		.filter((item) => item !== undefined && item !== null && item !== "")
		.map(String)
		.join(",");

const buildMapFilterPayload = ({
	id = "",
	groupCompanyId = "",
	companyId = "",
	countryId = "",
	stateId = "",
	districtCityId = "",
	locationId = "",
	relationTypeId = "",
} = {}) =>
	withKycCompanyCode({
		id: serializeMapFilterValue(id),
		groupCompanyIds: serializeMapFilterValue(groupCompanyId),
		companyIds: serializeMapFilterValue(companyId),
		countries: serializeMapFilterValue(countryId),
		states: serializeMapFilterValue(stateId),
		districtCities: serializeMapFilterValue(districtCityId),
		locations: serializeMapFilterValue(locationId),
		relationTypes: serializeMapFilterValue(relationTypeId),
	});

const buildMapCompanyLocationPayload = (filters = {}) => {
	const filterPayload = buildMapFilterPayload(filters);

	return withKycCompanyCode({
		groupCompanyIds: filterPayload.groupCompanyIds,
		companyIds: filterPayload.companyIds,
		countries: filterPayload.countries,
		states: filterPayload.states,
		districtCities: filterPayload.districtCities,
		locations: filterPayload.locations,
		relationTypes: filterPayload.relationTypes,
		routePolyline: filters.routePolyline || "",
		thresholdKm:
			Number.isFinite(Number(filters.thresholdKm)) ? Number(filters.thresholdKm) : 0,
	});
};

const MULTI_REDIRECT_ITEM_HEIGHT = 84;
const MULTI_REDIRECT_LIST_HEIGHT = 260;
const MULTI_REDIRECT_OVERSCAN = 8;

const KycMultiRedirectVirtualList = ({
	items,
	selectedIds,
	limit,
	onToggle,
}) => {
	const [scrollTop, setScrollTop] = useState(0);
	const selectedSet = useMemo(() => new Set(selectedIds), [selectedIds]);
	const selectedCount = selectedIds.length;

	const startIndex = Math.max(
		0,
		Math.floor(scrollTop / MULTI_REDIRECT_ITEM_HEIGHT) - MULTI_REDIRECT_OVERSCAN
	);
	const visibleCount =
		Math.ceil(MULTI_REDIRECT_LIST_HEIGHT / MULTI_REDIRECT_ITEM_HEIGHT) +
		MULTI_REDIRECT_OVERSCAN * 2;
	const endIndex = Math.min(items.length, startIndex + visibleCount);
	const visibleItems = items.slice(startIndex, endIndex);

	return (
		<div
			className="kyc-multi-redirect-modal__list"
			onScroll={(event) => setScrollTop(event.currentTarget.scrollTop)}>
			<div
				className="kyc-multi-redirect-modal__list-spacer"
				style={{ height: items.length * MULTI_REDIRECT_ITEM_HEIGHT }}>
				<div
					className="kyc-multi-redirect-modal__list-window"
					style={{ transform: `translateY(${startIndex * MULTI_REDIRECT_ITEM_HEIGHT}px)` }}>
					{visibleItems.map((marker, offset) => {
						const index = startIndex + offset;
						const checked = selectedSet.has(marker.id);
						const disableUnchecked = !checked && selectedCount >= limit;
						return (
							<label
								key={marker.id}
								className={`kyc-multi-redirect-modal__item${checked ? " is-checked" : ""
									}${disableUnchecked ? " is-disabled" : ""}`}>
								<input
									type="checkbox"
									className="kyc-multi-redirect-modal__checkbox"
									checked={checked}
									disabled={disableUnchecked}
									onChange={(event) =>
										onToggle(marker.id, event.target.checked)
									}
								/>
								<span className="kyc-multi-redirect-modal__item-index">
									{index + 1}
								</span>
								<span className="kyc-multi-redirect-modal__item-body">
									<span className="kyc-multi-redirect-modal__item-title">
										{marker.title}
									</span>
									<span className="kyc-multi-redirect-modal__item-address">
										{marker.address ||
											`${marker.position.lat}, ${marker.position.lng}`}
									</span>
									<span className="kyc-multi-redirect-modal__item-type">
										{getMapMarkerTypeLabel(marker.type)}
									</span>
								</span>
							</label>
						);
					})}
				</div>
			</div>
		</div>
	);
};

const KycMapView = ({ viewSwitch }) => {
	const mapPanelRef = useRef(null);
	const selectFromLocationRef = useRef(null);
	const mapFiltersShellRef = useRef(null);
	const markerInfoCloseTimerRef = useRef(null);
	const isPointerOverMarkerRef = useRef(false);
	const isPointerOverInfoWindowRef = useRef(false);
	const lastPointerPositionRef = useRef({ x: 0, y: 0 });
	const yearlyInvoiceFetchRef = useRef({ loadedKey: "", inflightKey: "", requestId: 0 });
	const [googleMap, setGoogleMap] = useState(null);
	const [userLocation, setUserLocation] = useState(null);
	const [userLocationBounds, setUserLocationBounds] = useState(undefined);
	const [mapLegendControlNode, setMapLegendControlNode] = useState(null);
	const [mapFullscreenControlNode, setMapFullscreenControlNode] = useState(null);
	const [groupCompanies, setGroupCompanies] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [countries, setCountries] = useState([]);
	const [states, setStates] = useState([]);
	const [districtCities, setDistrictCities] = useState([]);
	const [locations, setLocations] = useState([]);
	const [relationTypes, setRelationTypes] = useState([]);
	const [selectedGroupCompanyId, setSelectedGroupCompanyId] = useState([]);
	const [selectedCompanyId, setSelectedCompanyId] = useState([]);
	const [selectedCountryId, setSelectedCountryId] = useState([]);
	const [selectedStateId, setSelectedStateId] = useState([]);
	const [selectedDistrictCityId, setSelectedDistrictCityId] = useState([]);
	const [selectedLocationId, setSelectedLocationId] = useState([]);
	const [selectedRelationTypeId, setSelectedRelationTypeId] = useState([]);
	const [isGroupCompaniesLoading, setIsGroupCompaniesLoading] = useState(false);
	const [isCompaniesLoading, setIsCompaniesLoading] = useState(false);
	const [isCountriesLoading, setIsCountriesLoading] = useState(false);
	const [isStatesLoading, setIsStatesLoading] = useState(false);
	const [isDistrictCitiesLoading, setIsDistrictCitiesLoading] = useState(false);
	const [isLocationsLoading, setIsLocationsLoading] = useState(false);
	const [isRelationTypesLoading, setIsRelationTypesLoading] = useState(false);
	const [mapMarkers, setMapMarkers] = useState([]);
	const [mapLocationCounts, setMapLocationCounts] = useState(EMPTY_MAP_LOCATION_COUNTS);
	const [hasAppliedMapLocationSearch, setHasAppliedMapLocationSearch] = useState(false);
	const [mapViewportMarkerCount, setMapViewportMarkerCount] = useState(0);
	const [selectedMapMarker, setSelectedMapMarker] = useState(null);
	const [selectedContactMarker, setSelectedContactMarker] = useState(null);
	const [isMapInfoPanelVisible, setIsMapInfoPanelVisible] = useState(false);
	const [hasOpenedMapInfoPanel, setHasOpenedMapInfoPanel] = useState(false);
	const [accountSummary, setAccountSummary] = useState(null);
	const [outstandingAmountLcy, setOutstandingAmountLcy] = useState("");
	const [isAccountSummaryLoading, setIsAccountSummaryLoading] = useState(false);
	const [isMapLocationsLoading, setIsMapLocationsLoading] = useState(false);
	const [isSelectFromLocationOpen, setIsSelectFromLocationOpen] = useState(false);
	const [fromInputValue, setFromInputValue] = useState("");
	const [toInputValue, setToInputValue] = useState("");
	const [waypointInputValue, setWaypointInputValue] = useState("");
	const [fromPlace, setFromPlace] = useState(null);
	const [toPlace, setToPlace] = useState(null);
	const [waypointPlace, setWaypointPlace] = useState(null);
	const [selectFromLocationRelationTypeId, setSelectFromLocationRelationTypeId] =
		useState([]);
	const [directionsResult, setDirectionsResult] = useState(null);
	const [isMultiRedirectModalOpen, setIsMultiRedirectModalOpen] = useState(false);
	const [isMultiRedirectSelectMode, setIsMultiRedirectSelectMode] = useState(false);
	const [selectedMultiRedirectIds, setSelectedMultiRedirectIds] = useState([]);
	const [multiRedirectSearchValue, setMultiRedirectSearchValue] = useState("");
	const [isRouteSearching, setIsRouteSearching] = useState(false);
	const [isMapFiltersExpanded, setIsMapFiltersExpanded] = useState(true);
	const [isMapFullscreen, setIsMapFullscreen] = useState(false);
	const filterRequestIdsRef = useRef({
		groupCompany: 0,
		company: 0,
		country: 0,
		state: 0,
		districtCity: 0,
		location: 0,
		relationType: 0,
	});
	const { isLoaded: isGoogleMapLoaded, loadError: googleMapLoadError } = useJsApiLoader({
		id: "kyc-google-map",
		googleMapsApiKey,
		libraries: googleMapsLibraries,
		version: "weekly",
	});
	const googleMapOptions = useMemo(
		() => getGoogleMapOptions(),
		[isGoogleMapLoaded]
	);
	useEffect(() => {
		if (!isSelectFromLocationOpen) return undefined;

		const handleOutsideInteraction = (event) => {
			if (
				selectFromLocationRef.current &&
				!selectFromLocationRef.current.contains(event.target) &&
				!event.target.closest?.(".ant-select-dropdown")
			) {
				setIsSelectFromLocationOpen(false);
			}
		};

		document.addEventListener("mousedown", handleOutsideInteraction);
		document.addEventListener("touchstart", handleOutsideInteraction);

		return () => {
			document.removeEventListener("mousedown", handleOutsideInteraction);
			document.removeEventListener("touchstart", handleOutsideInteraction);
		};
	}, [isSelectFromLocationOpen]);

	useEffect(() => {
		return () => {
			if (markerInfoCloseTimerRef.current) {
				clearTimeout(markerInfoCloseTimerRef.current);
			}
		};
	}, []);

	const isPointerOverMapInfoWindow = (clientX, clientY) => {
		if (typeof document.elementsFromPoint !== "function") {
			return false;
		}

		return document
			.elementsFromPoint(clientX, clientY)
			.some(
				(element) =>
					element?.closest?.(
						".gm-style-iw-a, .gm-style-iw, .gm-style-iw-c, .gm-style-iw-d, .gm-style-iw-t, .gm-style-iw-chr, .kyc-map-marker-info"
					) != null
			);
	};

	const keepMapMarkerInfoOpen = () => {
		if (markerInfoCloseTimerRef.current) {
			clearTimeout(markerInfoCloseTimerRef.current);
			markerInfoCloseTimerRef.current = null;
		}
	};

	const closeMapMarkerInfo = () => {
		keepMapMarkerInfoOpen();
		isPointerOverMarkerRef.current = false;
		isPointerOverInfoWindowRef.current = false;
		setSelectedMapMarker(null);
	};

	const scheduleCloseMapMarkerInfo = (delayMs = 180) => {
		if (markerInfoCloseTimerRef.current) {
			clearTimeout(markerInfoCloseTimerRef.current);
		}

		markerInfoCloseTimerRef.current = setTimeout(() => {
			const { x, y } = lastPointerPositionRef.current;
			if (
				isPointerOverMarkerRef.current ||
				isPointerOverInfoWindowRef.current ||
				isPointerOverMapInfoWindow(x, y)
			) {
				markerInfoCloseTimerRef.current = null;
				return;
			}
			closeMapMarkerInfo();
			markerInfoCloseTimerRef.current = null;
		}, delayMs);
	};

	const openMapMarkerInfo = (marker) => {
		keepMapMarkerInfoOpen();
		isPointerOverMarkerRef.current = true;
		setSelectedMapMarker(marker);
	};

	const handleMarkerMouseOut = () => {
		isPointerOverMarkerRef.current = false;
		scheduleCloseMapMarkerInfo();
	};

	const handleInfoWindowMouseEnter = () => {
		isPointerOverInfoWindowRef.current = true;
		keepMapMarkerInfoOpen();
	};

	const handleInfoWindowMouseLeave = () => {
		isPointerOverInfoWindowRef.current = false;
		scheduleCloseMapMarkerInfo(120);
	};

	const resetYearlyInvoiceSummary = () => {
		yearlyInvoiceFetchRef.current = { loadedKey: "", inflightKey: "", requestId: yearlyInvoiceFetchRef.current.requestId + 1 };
		setAccountSummary(null);
		setOutstandingAmountLcy("");
		setIsAccountSummaryLoading(false);
	};

	const fetchYearlyInvoiceSummary = (marker) => {
		const accountKey = getMapMarkerAccountKey(marker);
		if (!accountKey) return;

		const fetchState = yearlyInvoiceFetchRef.current;
		if (fetchState.inflightKey === accountKey || fetchState.loadedKey === accountKey) {
			return;
		}

		const requestId = fetchState.requestId + 1;
		yearlyInvoiceFetchRef.current = {
			loadedKey: fetchState.loadedKey,
			inflightKey: accountKey,
			requestId,
		};

		const isGroup = marker?.type === "group";
		const companyId = marker?.companyId;
		const groupCompanyId = marker?.groupCompanyId;

		// cG_Id = groupCompanyId, customer_Organisation = companyId.
		// Only one identifier is sent; the other stays empty.
		const payload = withKycCompanyCode(
			isGroup
				? {
					cG_Id:
						groupCompanyId !== undefined &&
							groupCompanyId !== null &&
							String(groupCompanyId).trim() !== "" &&
							String(groupCompanyId) !== "0"
							? String(groupCompanyId)
							: "",
					customer_Organisation: "",
				}
				: {
					cG_Id: "",
					customer_Organisation:
						companyId !== undefined &&
							companyId !== null &&
							String(companyId).trim() !== "" &&
							String(companyId) !== "0"
							? String(companyId)
							: "",
				}
		);

		setIsAccountSummaryLoading(true);
		setAccountSummary(null);
		setOutstandingAmountLcy("");

		const fetchPaymentOutstandingAmount = (customerOrganizationIds) => {
			const sapCodes = String(customerOrganizationIds || "").trim();
			if (!sapCodes) {
				setOutstandingAmountLcy("");
				return;
			}

			EliteCardService.getPaymentTileCountsAPI({
				company_Code: getKycCompanyCode(),
				sortcolumn: "",
				orderBy: "desc",
				distributionChannel: "",
				country: "",
				priceGroup: "",
				salesOffice: "",
				search: "",
				pagesize: "10",
				year: null,
				quarter: null,
				general_Manager: "",
				continantal_Head: "",
				regional_Manager: "",
				area_Manager: "",
				groupIds: "",
				customer_OrganizationIds: sapCodes,
			})
				.then((response) => {
					if (yearlyInvoiceFetchRef.current.requestId !== requestId) return;
					if (response.data?.statusCode === 200) {
						const paymentData = response.data.responseData || {};
						setOutstandingAmountLcy(paymentData.totalPendingAmount_LCY || "");
					} else {
						setOutstandingAmountLcy("");
					}
				})
				.catch((error) => {
					if (yearlyInvoiceFetchRef.current.requestId !== requestId) return;
					console.log(error, "Error");
					setOutstandingAmountLcy("");
				});
		};

		return KycService.getKycMapYearlyInvoiceSummaryAPI(payload)
			.then((response) => {
				if (yearlyInvoiceFetchRef.current.requestId !== requestId) return;
				const summary = getYearlyInvoiceSummaryData(response);
				setAccountSummary(summary);
				yearlyInvoiceFetchRef.current.loadedKey = summary ? accountKey : "";
				yearlyInvoiceFetchRef.current.inflightKey = "";
				if (!summary) {
					NotificationManager.warning("No account summary found for this location.");
					return;
				}
				fetchPaymentOutstandingAmount(getSoldAccountSapCodes(summary));
			})
			.catch((error) => {
				if (yearlyInvoiceFetchRef.current.requestId !== requestId) return;
				yearlyInvoiceFetchRef.current.loadedKey = "";
				yearlyInvoiceFetchRef.current.inflightKey = "";
				setAccountSummary(null);
				NotificationManager.error(
					error?.message || "Unable to load yearly invoice summary."
				);
			})
			.finally(() => {
				if (yearlyInvoiceFetchRef.current.requestId !== requestId) return;
				setIsAccountSummaryLoading(false);
			});
	};

	const handleMarkerClick = (marker) => {
		openMapMarkerInfo(marker);
		setSelectedContactMarker(marker);
		setHasOpenedMapInfoPanel(true);
		setIsMapInfoPanelVisible(true);
		fetchYearlyInvoiceSummary(marker);
	};

	useKycMapCompanyCluster({
		map: googleMap,
		markers: mapMarkers,
		selectedMarkerId: selectedContactMarker?.id || null,
		getGoogleMarkerIcon,
		onMarkerClick: handleMarkerClick,
		onMarkerMouseOver: openMapMarkerInfo,
		onMarkerMouseOut: handleMarkerMouseOut,
	});

	useEffect(() => {
		if (!googleMap) {
			setMapViewportMarkerCount(0);
			return undefined;
		}

		const updateViewportMarkerCount = () => {
			const bounds = googleMap.getBounds?.();
			if (!bounds) {
				setMapViewportMarkerCount(0);
				return;
			}

			const visibleCount = (mapMarkers || []).reduce((total, marker) => {
				const lat = Number(marker?.position?.lat);
				const lng = Number(marker?.position?.lng);
				if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
					return total;
				}

				const position =
					typeof marker.position.lat === "function"
						? marker.position
						: { lat, lng };

				return bounds.contains(position) ? total + 1 : total;
			}, 0);

			setMapViewportMarkerCount(visibleCount);
		};

		updateViewportMarkerCount();
		const idleListener = googleMap.addListener("idle", updateViewportMarkerCount);

		return () => {
			window.google?.maps?.event?.removeListener(idleListener);
		};
	}, [googleMap, mapMarkers]);

	useEffect(() => {
		let cancelled = false;

		getUserGeoPosition()
			.then((position) => {
				if (cancelled) return;
				const latitude = Number(position?.coords?.latitude);
				const longitude = Number(position?.coords?.longitude);
				if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
					return;
				}
				setUserLocation({ lat: latitude, lng: longitude });
			})
			.catch((error) => {
				if (cancelled) return;
				console.error("Unable to get location:", error?.message || error);
			});

		return () => {
			cancelled = true;
		};
	}, []);

	useEffect(() => {
		if (!userLocation || !isGoogleMapLoaded) return undefined;
		let cancelled = false;

		getViewportForUserLocation(userLocation).then((viewport) => {
			if (cancelled) return;
			setUserLocationBounds(viewport);
		});

		return () => {
			cancelled = true;
		};
	}, [userLocation, isGoogleMapLoaded]);

	useEffect(() => {
		if (!googleMap || !userLocation || !window.google?.maps?.OverlayView) {
			return undefined;
		}

		const OverlayClass = getUserLocationOverlayClass();
		if (!OverlayClass) return undefined;

		const overlay = new OverlayClass(userLocation);
		overlay.setMap(googleMap);

		return () => {
			overlay.setMap(null);
		};
	}, [googleMap, userLocation]);

	useEffect(() => {
		if (!googleMap || !window.google?.maps?.ControlPosition) {
			setMapLegendControlNode(null);
			setMapFullscreenControlNode(null);
			return undefined;
		}

		const legendDiv = document.createElement("div");
		legendDiv.className = "kyc-map-legend-control";
		const topRightControls =
			googleMap.controls[window.google.maps.ControlPosition.TOP_RIGHT];
		topRightControls.push(legendDiv);
		setMapLegendControlNode(legendDiv);

		const fullscreenDiv = document.createElement("div");
		fullscreenDiv.className = "kyc-map-fullscreen-control";
		const bottomRightControls =
			googleMap.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM];
		bottomRightControls.push(fullscreenDiv);
		setMapFullscreenControlNode(fullscreenDiv);

		return () => {
			setMapLegendControlNode(null);
			setMapFullscreenControlNode(null);
			try {
				const legendItems = topRightControls.getArray();
				const legendIndex = legendItems.indexOf(legendDiv);
				if (legendIndex > -1) {
					topRightControls.removeAt(legendIndex);
				}
			} catch (error) {
				// Map instance may already be gone on unmount.
			}
			try {
				const fullscreenItems = bottomRightControls.getArray();
				const fullscreenIndex = fullscreenItems.indexOf(fullscreenDiv);
				if (fullscreenIndex > -1) {
					bottomRightControls.removeAt(fullscreenIndex);
				}
			} catch (error) {
				// Map instance may already be gone on unmount.
			}
		};
	}, [googleMap]);

	useEffect(() => {
		if (!selectedMapMarker) return undefined;

		const handlePointerMove = (event) => {
			lastPointerPositionRef.current = {
				x: event.clientX,
				y: event.clientY,
			};

			if (
				isPointerOverMarkerRef.current ||
				isPointerOverInfoWindowRef.current ||
				isPointerOverMapInfoWindow(event.clientX, event.clientY)
			) {
				keepMapMarkerInfoOpen();
				return;
			}

			scheduleCloseMapMarkerInfo();
		};

		document.addEventListener("mousemove", handlePointerMove);
		return () => document.removeEventListener("mousemove", handlePointerMove);
	}, [selectedMapMarker]);

	// Bind hover close to the full Google InfoWindow chrome (not only React content).
	useEffect(() => {
		if (!selectedMapMarker) {
			isPointerOverInfoWindowRef.current = false;
			return undefined;
		}

		let iwRoot = null;

		const onEnter = () => {
			isPointerOverInfoWindowRef.current = true;
			if (markerInfoCloseTimerRef.current) {
				clearTimeout(markerInfoCloseTimerRef.current);
				markerInfoCloseTimerRef.current = null;
			}
		};

		const onLeave = () => {
			isPointerOverInfoWindowRef.current = false;
			if (markerInfoCloseTimerRef.current) {
				clearTimeout(markerInfoCloseTimerRef.current);
			}
			markerInfoCloseTimerRef.current = setTimeout(() => {
				const { x, y } = lastPointerPositionRef.current;
				if (
					isPointerOverMarkerRef.current ||
					isPointerOverInfoWindowRef.current ||
					isPointerOverMapInfoWindow(x, y)
				) {
					markerInfoCloseTimerRef.current = null;
					return;
				}
				isPointerOverMarkerRef.current = false;
				isPointerOverInfoWindowRef.current = false;
				setSelectedMapMarker(null);
				markerInfoCloseTimerRef.current = null;
			}, 120);
		};

		const bindTimer = window.setTimeout(() => {
			iwRoot =
				document.querySelector(".gm-style-iw-a") ||
				document.querySelector(".gm-style-iw-c");
			if (!iwRoot) return;
			iwRoot.addEventListener("mouseenter", onEnter);
			iwRoot.addEventListener("mouseleave", onLeave);
		}, 0);

		return () => {
			window.clearTimeout(bindTimer);
			if (iwRoot) {
				iwRoot.removeEventListener("mouseenter", onEnter);
				iwRoot.removeEventListener("mouseleave", onLeave);
			}
			isPointerOverInfoWindowRef.current = false;
		};
	}, [selectedMapMarker]);

	useEffect(() => {
		if (!googleMap) return;

		window.google?.maps?.event?.trigger(googleMap, "resize");

		if (directionsResult?.routes?.[0]?.bounds) {
			googleMap.fitBounds(directionsResult.routes[0].bounds, 48);
			return;
		}

		if (!mapMarkers.length) {
			if (userLocation) {
				if (userLocationBounds === undefined) {
					return;
				}
				if (userLocationBounds) {
					googleMap.fitBounds(userLocationBounds, 48);
				} else {
					googleMap.setCenter(userLocation);
					googleMap.setZoom(USER_LOCATION_AREA_ZOOM);
				}
				return;
			}
			googleMap.setCenter(DEFAULT_MAP_CENTER);
			googleMap.setZoom(DEFAULT_MAP_ZOOM);
			return;
		}

		if (mapMarkers.length === 1) {
			googleMap.setCenter(mapMarkers[0].position);
			googleMap.setZoom(8);
			return;
		}

		const bounds = new window.google.maps.LatLngBounds();
		mapMarkers.forEach((marker) => bounds.extend(marker.position));
		googleMap.fitBounds(bounds, 40);
	}, [
		googleMap,
		mapMarkers,
		directionsResult,
		userLocation,
		userLocationBounds,
	]);

	useEffect(() => {
		if (!googleMap) return undefined;

		const handleWindowResize = () => {
			const center = googleMap.getCenter();
			const zoom = googleMap.getZoom();
			window.google?.maps?.event?.trigger(googleMap, "resize");
			if (center) googleMap.setCenter(center);
			if (zoom != null) googleMap.setZoom(zoom);
		};

		window.addEventListener("resize", handleWindowResize);
		return () => window.removeEventListener("resize", handleWindowResize);
	}, [googleMap]);

	useEffect(() => {
		const fullscreenResizeTimers = [];
		const syncMapFullscreen = () => {
			const panel = mapPanelRef.current;
			const fullscreenEl = getFullscreenElement();
			const isFullscreen = isKycMapFullscreenElement(panel, fullscreenEl);
			setIsMapFullscreen(isFullscreen);
			setKycMapFullscreenMetrics(isFullscreen, panel, googleMap, isMapInfoPanelVisible);
			window.requestAnimationFrame(() => {
				setKycMapFullscreenMetrics(
					isFullscreen,
					mapPanelRef.current,
					googleMap,
					isMapInfoPanelVisible
				);
			});
			fullscreenResizeTimers.push(
				window.setTimeout(() => {
					setKycMapFullscreenMetrics(
						isFullscreen,
						mapPanelRef.current,
						googleMap,
						isMapInfoPanelVisible
					);
				}, 80)
			);
			fullscreenResizeTimers.push(
				window.setTimeout(() => {
					setKycMapFullscreenMetrics(
						isFullscreen,
						mapPanelRef.current,
						googleMap,
						isMapInfoPanelVisible
					);
				}, 280)
			);
		};

		document.addEventListener("fullscreenchange", syncMapFullscreen);
		document.addEventListener("webkitfullscreenchange", syncMapFullscreen);
		document.addEventListener("MSFullscreenChange", syncMapFullscreen);
		return () => {
			fullscreenResizeTimers.forEach((timer) => window.clearTimeout(timer));
			document.removeEventListener("fullscreenchange", syncMapFullscreen);
			document.removeEventListener("webkitfullscreenchange", syncMapFullscreen);
			document.removeEventListener("MSFullscreenChange", syncMapFullscreen);
			setKycMapFullscreenMetrics(false, mapPanelRef.current, googleMap, false);
			document.documentElement.classList.remove("kyc-map-fs");
		};
	}, [googleMap, isMapInfoPanelVisible]);

	useEffect(() => {
		if (!isMapFullscreen) return undefined;

		const applyViewportSize = () => {
			setKycMapFullscreenMetrics(true, mapPanelRef.current, googleMap, isMapInfoPanelVisible);
		};

		window.addEventListener("resize", applyViewportSize);
		const panel = mapPanelRef.current;
		if (!panel || typeof ResizeObserver === "undefined") {
			return () => window.removeEventListener("resize", applyViewportSize);
		}

		const observer = new ResizeObserver(applyViewportSize);
		observer.observe(panel);
		return () => {
			observer.disconnect();
			window.removeEventListener("resize", applyViewportSize);
		};
	}, [googleMap, isMapFullscreen, isMapInfoPanelVisible]);

	const toggleMapInfoPanel = () => {
		setIsMapInfoPanelVisible((open) => !open);
	};

	const toggleMapFullscreen = () => {
		const panel = mapPanelRef.current;
		if (!panel) return;

		const fullscreenEl = getFullscreenElement();
		if (fullscreenEl) {
			setIsMapFullscreen(false);
			setKycMapFullscreenMetrics(false, panel, googleMap);
			const exitFullscreen =
				document.exitFullscreen ||
				document.webkitExitFullscreen ||
				document.msExitFullscreen;
			exitFullscreen?.call(document);
			return;
		}

		const requestFullscreen =
			panel.requestFullscreen ||
			panel.webkitRequestFullscreen ||
			panel.webkitRequestFullScreen ||
			panel.msRequestFullscreen;
		setIsMapFullscreen(true);
		setKycMapFullscreenMetrics(true, panel, googleMap, isMapInfoPanelVisible);
		let requestResult;
		try {
			requestResult = requestFullscreen?.call(panel, { navigationUI: "hide" });
		} catch (error) {
			requestResult = requestFullscreen?.call(panel);
		}
		if (requestResult && typeof requestResult.catch === "function") {
			requestResult.catch((error) => {
				setIsMapFullscreen(false);
				setKycMapFullscreenMetrics(false, panel, googleMap, false);
				console.error("Unable to open map fullscreen:", error?.message || error);
			});
		}
	};

	// Panel open/close only resizes the map canvas — keep current center/zoom.
	useEffect(() => {
		if (!googleMap) return undefined;

		if (isMapFullscreen) {
			setKycMapFullscreenMetrics(
				true,
				mapPanelRef.current,
				googleMap,
				isMapInfoPanelVisible
			);
		}

		const preserveViewportAfterResize = () => {
			const center = googleMap.getCenter();
			const zoom = googleMap.getZoom();
			window.google?.maps?.event?.trigger(googleMap, "resize");
			if (center) googleMap.setCenter(center);
			if (zoom != null) googleMap.setZoom(zoom);
		};

		preserveViewportAfterResize();
		const resizeTimer = window.setTimeout(preserveViewportAfterResize, 340);
		return () => window.clearTimeout(resizeTimer);
	}, [googleMap, isMapInfoPanelVisible, isMapFullscreen]);

	const intersectSelectedOptions = (selected, options) => {
		const valid = new Set((options || []).map((item) => String(item.value)));
		return (Array.isArray(selected) ? selected : []).filter((id) =>
			valid.has(String(id))
		);
	};

	const fetchMapFilterOptions = (key, request, setOptions, setLoading, errorMessage) => {
		const requestId = ++filterRequestIdsRef.current[key];
		setLoading(true);
		return request()
			.then((response) => {
				if (requestId !== filterRequestIdsRef.current[key]) return null;
				const options = toMapSelectOptions(getMapResponseList(response));
				setOptions(options);
				return options;
			})
			.catch((error) => {
				if (requestId !== filterRequestIdsRef.current[key]) return null;
				setOptions([]);
				NotificationManager.error(error?.message || errorMessage);
				return [];
			})
			.finally(() => {
				if (requestId === filterRequestIdsRef.current[key]) {
					setLoading(false);
				}
			});
	};

	const getLinkedFilterPayload = (filters, omitKey) =>
		buildMapFilterPayload({
			...filters,
			...(omitKey ? { [omitKey]: [] } : {}),
		});

	const loadGroupCompanyOptions = (filters) =>
		fetchMapFilterOptions(
			"groupCompany",
			() =>
				KycService.getKycMapGroupCompanyAPI(
					getLinkedFilterPayload(filters, "groupCompanyId")
				),
			setGroupCompanies,
			setIsGroupCompaniesLoading,
			"Unable to load group companies."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.groupCompanyId, options);
			setSelectedGroupCompanyId(next);
			return next;
		});

	const loadCompanyOptions = (filters) =>
		fetchMapFilterOptions(
			"company",
			() =>
				KycService.getKycMapCompanyAPI(getLinkedFilterPayload(filters, "companyId")),
			setCompanies,
			setIsCompaniesLoading,
			"Unable to load companies."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.companyId, options);
			setSelectedCompanyId(next);
			return next;
		});

	const loadLocationOptions = (filters) =>
		fetchMapFilterOptions(
			"location",
			() =>
				KycService.getKycMapFormattedAddressAPI(
					getLinkedFilterPayload(filters, "locationId")
				),
			setLocations,
			setIsLocationsLoading,
			"Unable to load locations."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.locationId, options);
			setSelectedLocationId(next);
			return next;
		});

	const loadRelationTypeOptions = (filters) =>
		fetchMapFilterOptions(
			"relationType",
			() =>
				KycService.getKycMapRelationTypeAPI(
					getLinkedFilterPayload(filters, "relationTypeId")
				),
			setRelationTypes,
			setIsRelationTypesLoading,
			"Unable to load relation types."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.relationTypeId, options);
			setSelectedRelationTypeId(next);
			return next;
		});

	const loadDistrictCityOptions = (filters) => {
		if (!serializeMapFilterValue(filters.stateId)) {
			filterRequestIdsRef.current.districtCity += 1;
			setDistrictCities([]);
			setSelectedDistrictCityId([]);
			return Promise.resolve([]);
		}

		return fetchMapFilterOptions(
			"districtCity",
			() =>
				KycService.getKycMapDistrictCityAPI(
					getLinkedFilterPayload(filters, "districtCityId")
				),
			setDistrictCities,
			setIsDistrictCitiesLoading,
			"Unable to load districts/cities."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.districtCityId, options);
			setSelectedDistrictCityId(next);
			return next;
		});
	};

	const loadStateOptions = (filters) => {
		if (!serializeMapFilterValue(filters.countryId)) {
			filterRequestIdsRef.current.state += 1;
			filterRequestIdsRef.current.districtCity += 1;
			setStates([]);
			setDistrictCities([]);
			setSelectedStateId([]);
			setSelectedDistrictCityId([]);
			return Promise.resolve([]);
		}

		return fetchMapFilterOptions(
			"state",
			() => KycService.getKycMapStateAPI(getLinkedFilterPayload(filters, "stateId")),
			setStates,
			setIsStatesLoading,
			"Unable to load states."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.stateId, options);
			setSelectedStateId(next);
			if (!next.length) {
				filterRequestIdsRef.current.districtCity += 1;
				setDistrictCities([]);
				setSelectedDistrictCityId([]);
				return next;
			}
			return loadDistrictCityOptions({ ...filters, stateId: next }).then(() => next);
		});
	};

	const loadCountryOptions = (filters) =>
		fetchMapFilterOptions(
			"country",
			() =>
				KycService.getKycMapCountryAPI(getLinkedFilterPayload(filters, "countryId")),
			setCountries,
			setIsCountriesLoading,
			"Unable to load countries."
		).then((options) => {
			if (!options) return [];
			const next = intersectSelectedOptions(filters.countryId, options);
			setSelectedCountryId(next);
			if (!next.length) {
				filterRequestIdsRef.current.state += 1;
				filterRequestIdsRef.current.districtCity += 1;
				setStates([]);
				setDistrictCities([]);
				setSelectedStateId([]);
				setSelectedDistrictCityId([]);
				return next;
			}
			return loadStateOptions({ ...filters, countryId: next }).then(() => next);
		});

	const loadUnfilteredMapFilters = () => {
		const emptyPayload = buildMapFilterPayload();
		filterRequestIdsRef.current.state += 1;
		filterRequestIdsRef.current.districtCity += 1;
		setStates([]);
		setDistrictCities([]);
		fetchMapFilterOptions(
			"groupCompany",
			() => KycService.getKycMapGroupCompanyAPI(emptyPayload),
			setGroupCompanies,
			setIsGroupCompaniesLoading,
			"Unable to load group companies."
		);
		fetchMapFilterOptions(
			"company",
			() => KycService.getKycMapCompanyAPI(emptyPayload),
			setCompanies,
			setIsCompaniesLoading,
			"Unable to load companies."
		);
		fetchMapFilterOptions(
			"country",
			() => KycService.getKycMapCountryAPI(emptyPayload),
			setCountries,
			setIsCountriesLoading,
			"Unable to load countries."
		);
		fetchMapFilterOptions(
			"location",
			() => KycService.getKycMapFormattedAddressAPI(emptyPayload),
			setLocations,
			setIsLocationsLoading,
			"Unable to load locations."
		);
		fetchMapFilterOptions(
			"relationType",
			() => KycService.getKycMapRelationTypeAPI(emptyPayload),
			setRelationTypes,
			setIsRelationTypesLoading,
			"Unable to load relation types."
		);
	};

	const fetchCompanyLocationList = (filters = {}) => {
		const payload = buildMapCompanyLocationPayload(filters);

		setIsMapLocationsLoading(true);
		KycService.getKycMapCompanyLocationListAPI(payload)
			.then((response) => {
				setSelectedMapMarker(null);
				setSelectedContactMarker(null);
				setHasOpenedMapInfoPanel(false);
				setIsMapInfoPanelVisible(false);
				resetYearlyInvoiceSummary();
				const markers = toMapMarkers(getMapResponseList(response));
				setMapMarkers(markers);
				setMapLocationCounts(resolveMapLocationCounts(response, markers));
				setHasAppliedMapLocationSearch(true);
			})
			.catch((error) => {
				setSelectedMapMarker(null);
				setSelectedContactMarker(null);
				setHasOpenedMapInfoPanel(false);
				setIsMapInfoPanelVisible(false);
				resetYearlyInvoiceSummary();
				setMapMarkers([]);
				setMapLocationCounts(EMPTY_MAP_LOCATION_COUNTS);
				setHasAppliedMapLocationSearch(true);
				NotificationManager.error(error?.message || "Unable to load map locations.");
			})
			.finally(() => {
				setIsMapLocationsLoading(false);
			});
	};

	const clearTopMapFilters = () => {
		setSelectedGroupCompanyId([]);
		setSelectedCompanyId([]);
		setSelectedCountryId([]);
		setSelectedStateId([]);
		setSelectedDistrictCityId([]);
		setSelectedLocationId([]);
		setSelectedRelationTypeId([]);
		loadUnfilteredMapFilters();
	};

	const clearSelectFromLocationRoute = ({ clearMarkers = false } = {}) => {
		setFromInputValue("");
		setToInputValue("");
		setWaypointInputValue("");
		setFromPlace(null);
		setToPlace(null);
		setWaypointPlace(null);
		setSelectFromLocationRelationTypeId([]);
		setDirectionsResult(null);

		if (clearMarkers) {
			setMapMarkers([]);
			setMapLocationCounts(EMPTY_MAP_LOCATION_COUNTS);
			setHasAppliedMapLocationSearch(false);
			setSelectedMapMarker(null);
			setSelectedContactMarker(null);
			setHasOpenedMapInfoPanel(false);
			setIsMapInfoPanelVisible(false);
			resetYearlyInvoiceSummary();
		}
	};

	const fetchRouteCompanyLocations = (locationFilter = {}, directions = null) => {
		// Route search is exclusive of top filters: send empty group/company/geo filters.
		const payload = {
			groupCompanyIds: "",
			companyIds: "",
			countries: locationFilter.countries || "",
			states: "",
			districtCities: "",
			locations: "",
			relationTypes: serializeMapFilterValue(selectFromLocationRelationTypeId),
			routePolyline: getEncodedRoutePolyline(directions),
			thresholdKm: ROUTE_THRESHOLD_KM,
		};

		setIsMapLocationsLoading(true);
		return KycService.getKycMapCompanyLocationListAPI(payload)
			.then((response) => {
				const allMarkers = toMapMarkers(getMapResponseList(response));
				const pathCoordinates = getDirectionsPathCoordinates(directions);
				const stopPoints = [
					extractLocation(fromPlace),
					extractLocation(toPlace),
					waypointPlace ? extractLocation(waypointPlace) : null,
				].filter((stop) => stop?.lat != null && stop?.lng != null);

				const nearbyMarkers = filterMarkersNearRoute(
					allMarkers,
					pathCoordinates,
					stopPoints,
					ROUTE_THRESHOLD_KM
				);

				setSelectedMapMarker(null);
				setSelectedContactMarker(null);
				setHasOpenedMapInfoPanel(false);
				setIsMapInfoPanelVisible(false);
				resetYearlyInvoiceSummary();
				setMapMarkers(nearbyMarkers);
				setMapLocationCounts(
					nearbyMarkers.length === allMarkers.length
						? resolveMapLocationCounts(response, nearbyMarkers)
						: countMapMarkersByType(nearbyMarkers)
				);
				setHasAppliedMapLocationSearch(true);

				if (allMarkers.length && !nearbyMarkers.length) {
					NotificationManager.info(
						"No companies found near this route. Try a different From/To location."
					);
				}
			})
			.catch((error) => {
				setSelectedMapMarker(null);
				setSelectedContactMarker(null);
				setHasOpenedMapInfoPanel(false);
				setIsMapInfoPanelVisible(false);
				resetYearlyInvoiceSummary();
				setMapMarkers([]);
				setMapLocationCounts(EMPTY_MAP_LOCATION_COUNTS);
				setHasAppliedMapLocationSearch(true);
				NotificationManager.error(error?.message || "Unable to load map locations.");
			})
			.finally(() => {
				setIsMapLocationsLoading(false);
			});
	};

	useEffect(() => {
		loadUnfilteredMapFilters();
	}, []);

	const mapFilterSelections = [
		selectedGroupCompanyId,
		selectedCompanyId,
		selectedCountryId,
		selectedStateId,
		selectedDistrictCityId,
		selectedLocationId,
		selectedRelationTypeId,
	];
	const hasSelectedMapFilters = mapFilterSelections.some(
		(value) => Array.isArray(value) && value.length > 0
	);
	const activeMapFilterCount = mapFilterSelections.reduce(
		(total, value) => total + (Array.isArray(value) ? value.length : 0),
		0
	);

	const filteredMultiRedirectMarkers = useMemo(() => {
		if (!isMultiRedirectModalOpen || !isMultiRedirectSelectMode) {
			return [];
		}

		const query = multiRedirectSearchValue.trim().toLowerCase();
		if (!query) {
			return mapMarkers;
		}

		return mapMarkers.filter((marker) => {
			const typeLabel = getMapMarkerTypeLabel(marker.type);
			const haystack = `${marker.title} ${marker.address} ${typeLabel}`;
			return haystack.toLowerCase().includes(query);
		});
	}, [
		isMultiRedirectModalOpen,
		isMultiRedirectSelectMode,
		mapMarkers,
		multiRedirectSearchValue,
	]);

	const handleApplyFilters = () => {
		if (!hasSelectedMapFilters) return;

		// Top filters and Select From Location are mutually exclusive.
		clearSelectFromLocationRoute();
		setSelectedMapMarker(null);
		setSelectedContactMarker(null);
		setHasOpenedMapInfoPanel(false);
		setIsMapInfoPanelVisible(false);
		resetYearlyInvoiceSummary();
		setIsMapFiltersExpanded(false);
		setIsSelectFromLocationOpen(false);

		fetchCompanyLocationList({
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: selectedDistrictCityId,
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		});
	};

	const handleResetMapFilters = () => {
		clearTopMapFilters();
		clearSelectFromLocationRoute({ clearMarkers: true });
		setIsSelectFromLocationOpen(false);
	};

	const scrollToMapFilters = () => {
		window.setTimeout(() => {
			mapFiltersShellRef.current?.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}, 80);
	};

	const handleMapFiltersClick = () => {
		if (!isMapFiltersExpanded) {
			setIsMapFiltersExpanded(true);
			scrollToMapFilters();
			return;
		}

		const rect = mapFiltersShellRef.current?.getBoundingClientRect();
		const stickyOffset = 130;
		if (rect && rect.top < stickyOffset) {
			scrollToMapFilters();
			return;
		}

		setIsMapFiltersExpanded(false);
	};

	const handleFromPlaceSelected = (place) => {
		const extracted = extractLocation(place);
		setFromPlace(place);
		setFromInputValue(extracted.label || place.name || fromInputValue);
	};

	const handleToPlaceSelected = (place) => {
		const extracted = extractLocation(place);
		setToPlace(place);
		setToInputValue(extracted.label || place.name || toInputValue);
	};

	const handleWaypointPlaceSelected = (place) => {
		const extracted = extractLocation(place);
		setWaypointPlace(place);
		setWaypointInputValue(extracted.label || place.name || waypointInputValue);
	};

	const handleSwapRouteLocations = () => {
		setFromPlace(toPlace);
		setToPlace(fromPlace);
		setFromInputValue(toInputValue);
		setToInputValue(fromInputValue);
	};

	const handleResetSelectFromLocation = () => {
		clearSelectFromLocationRoute({ clearMarkers: true });
	};

	const handleOpenMultiRedirectModal = () => {
		if (!mapMarkers.length) {
			NotificationManager.warning("Apply a filter or search a route to load locations first.");
			return;
		}

		setSelectedMultiRedirectIds([]);
		setMultiRedirectSearchValue("");
		setIsMultiRedirectSelectMode(true);
		setIsMultiRedirectModalOpen(true);
	};

	const handleCloseMultiRedirectModal = () => {
		setIsMultiRedirectModalOpen(false);
		setIsMultiRedirectSelectMode(false);
		setSelectedMultiRedirectIds([]);
		setMultiRedirectSearchValue("");
	};

	const handleOpenFirstMultiRedirectMarkers = () => {
		const markersToOpen = mapMarkers.slice(0, GOOGLE_MAPS_MULTI_REDIRECT_LIMIT);
		const opened = openGoogleMapsDirections(markersToOpen);
		if (opened) {
			handleCloseMultiRedirectModal();
		}
	};

	const handleToggleMultiRedirectMarker = (markerId, checked) => {
		setSelectedMultiRedirectIds((prev) => {
			if (checked) {
				if (prev.includes(markerId)) return prev;
				if (prev.length >= GOOGLE_MAPS_MULTI_REDIRECT_LIMIT) {
					NotificationManager.warning(
						`You can select up to ${GOOGLE_MAPS_MULTI_REDIRECT_LIMIT} locations at once.`
					);
					return prev;
				}
				return [...prev, markerId];
			}
			return prev.filter((id) => id !== markerId);
		});
	};

	const handleOpenSelectedMultiRedirectMarkers = () => {
		const selectedMarkers = mapMarkers.filter((marker) =>
			selectedMultiRedirectIds.includes(marker.id)
		);
		if (!selectedMarkers.length) {
			NotificationManager.warning("Please select at least one location.");
			return;
		}
		if (selectedMarkers.length > GOOGLE_MAPS_MULTI_REDIRECT_LIMIT) {
			NotificationManager.warning(
				`Please select up to ${GOOGLE_MAPS_MULTI_REDIRECT_LIMIT} locations only.`
			);
			return;
		}
		const opened = openGoogleMapsDirections(selectedMarkers);
		if (opened) {
			handleCloseMultiRedirectModal();
		}
	};

	const handleRouteSearch = () => {
		const fromLocation = getPlaceGeometryLocation(fromPlace);
		const toLocation = getPlaceGeometryLocation(toPlace);

		if (!fromLocation || !toLocation) {
			NotificationManager.warning("Please select both From and To locations from suggestions.");
			return;
		}

		if (!window.google?.maps?.DirectionsService) {
			NotificationManager.error("Google Directions is not available yet. Please try again.");
			return;
		}

		const waypointLocation =
			waypointPlace ? getPlaceGeometryLocation(waypointPlace) : null;
		const waypoints = waypointLocation
			? [{ location: waypointLocation, stopover: true }]
			: [];

		setIsRouteSearching(true);
		const directionsService = new window.google.maps.DirectionsService();
		directionsService.route(
			{
				origin: fromLocation,
				destination: toLocation,
				waypoints,
				travelMode: window.google.maps.TravelMode.DRIVING,
				optimizeWaypoints: false,
			},
			(result, status) => {
				if (status !== window.google.maps.DirectionsStatus.OK || !result) {
					setDirectionsResult(null);
					setIsRouteSearching(false);
					NotificationManager.error("Unable to find a driving route for the selected locations.");
					return;
				}

				// Top filters and Select From Location are mutually exclusive.
				clearTopMapFilters();
				setDirectionsResult(result);
				const locationFilter = buildLocationFilter(
					fromPlace,
					toPlace,
					waypointPlace ? [waypointPlace] : []
				);
				fetchRouteCompanyLocations(locationFilter, result).finally(() => {
					setIsRouteSearching(false);
				});
			}
		);
	};

	const handleGroupCompanyChange = (value) => {
		setSelectedGroupCompanyId(value);
		const filters = {
			groupCompanyId: value,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: selectedDistrictCityId,
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadCompanyOptions(linkedFilters);
		loadLocationOptions(filters);
		loadCountryOptions(linkedFilters);
		loadRelationTypeOptions(linkedFilters);
	};

	const handleCompanyChange = (value) => {
		setSelectedCompanyId(value);
		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: value,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: selectedDistrictCityId,
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadLocationOptions(filters);
		loadGroupCompanyOptions(linkedFilters);
		loadCountryOptions(linkedFilters);
		loadRelationTypeOptions(linkedFilters);
	};

	const handleCountryChange = (value) => {
		setSelectedCountryId(value);
		filterRequestIdsRef.current.state += 1;
		filterRequestIdsRef.current.districtCity += 1;
		setSelectedStateId([]);
		setSelectedDistrictCityId([]);
		setStates([]);
		setDistrictCities([]);

		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: value,
			stateId: [],
			districtCityId: [],
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadGroupCompanyOptions(linkedFilters);
		loadCompanyOptions(linkedFilters);
		loadLocationOptions(filters);
		loadStateOptions(linkedFilters);
		loadRelationTypeOptions(linkedFilters);
	};

	const handleStateChange = (value) => {
		setSelectedStateId(value);
		filterRequestIdsRef.current.districtCity += 1;
		setSelectedDistrictCityId([]);
		setDistrictCities([]);

		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: value,
			districtCityId: [],
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadGroupCompanyOptions(linkedFilters);
		loadCompanyOptions(linkedFilters);
		loadLocationOptions(filters);
		loadDistrictCityOptions(linkedFilters);
		loadRelationTypeOptions(linkedFilters);
	};

	const handleDistrictCityChange = (value) => {
		setSelectedDistrictCityId(value);
		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: value,
			locationId: selectedLocationId,
			relationTypeId: selectedRelationTypeId,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadGroupCompanyOptions(linkedFilters);
		loadCompanyOptions(linkedFilters);
		loadLocationOptions(filters);
		loadRelationTypeOptions(linkedFilters);
	};

	const handleLocationChange = (value) => {
		setSelectedLocationId(value);
		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: selectedDistrictCityId,
			locationId: value,
			relationTypeId: selectedRelationTypeId,
		};
		loadRelationTypeOptions(filters);
	};

	const handleRelationTypeChange = (value) => {
		setSelectedRelationTypeId(value);
		const filters = {
			groupCompanyId: selectedGroupCompanyId,
			companyId: selectedCompanyId,
			countryId: selectedCountryId,
			stateId: selectedStateId,
			districtCityId: selectedDistrictCityId,
			locationId: selectedLocationId,
			relationTypeId: value,
		};
		const linkedFilters = { ...filters, locationId: [] };
		loadGroupCompanyOptions(linkedFilters);
		loadCompanyOptions(linkedFilters);
		loadCountryOptions(linkedFilters);
		loadLocationOptions(filters);
	};

	const mapFullscreenButton = (
		<button
			type="button"
			className="kyc-map-fullscreen-btn"
			onClick={toggleMapFullscreen}
			title={isMapFullscreen ? "Exit fullscreen" : "Toggle fullscreen view"}
			aria-label={isMapFullscreen ? "Exit fullscreen" : "Toggle fullscreen view"}>
			<img
				src={isMapFullscreen ? mapFullscreenExitIcon : mapFullscreenEnterIcon}
				alt=""
				aria-hidden
			/>
		</button>
	);

	return (
		<Fragment>
			<KycStickyTopBar className="kyc-dashboard-top-bar details_view_title kyc-dashboard-top-bar--map">
				<div className="kyc-dashboard-top-bar__left">
					<h2 className="kyc-page-title">
						Company Locator
						<span className="kyc-page-title__note">
							(Click the right-side button to open filters)
						</span>
					</h2>
				</div>
				<div className="kyc-dashboard-top-bar__actions">
					<button
						type="button"
						className={`kyc-map-filters-icon-btn${isMapFiltersExpanded ? " is-open" : ""
							}`}
						onClick={handleMapFiltersClick}
						aria-expanded={isMapFiltersExpanded}
						aria-controls="kyc-map-filters-panel"
						aria-label="Filters"
						title="Filters">
						<img src={imgFilter} alt="" aria-hidden />
						{activeMapFilterCount > 0 ? (
							<em className="kyc-map-filters-icon-btn__badge">
								{activeMapFilterCount}
							</em>
						) : null}
					</button>
					{viewSwitch}
				</div>
			</KycStickyTopBar>
			<div
				ref={mapFiltersShellRef}
				className={`kyc-map-filters-shell${isMapFiltersExpanded ? " is-open" : ""
					}`}>
				<div
					id="kyc-map-filters-panel"
					className={`kyc-map-filters-panel${isMapFiltersExpanded ? " is-open" : ""
						}`}>
					<div className="kyc-map-filters-panel__inner">
						<div className="kyc-map-filters">
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isGroupCompaniesLoading)}
								optionFilterProp="label"
								placeholder="Group Company Name"
								loading={isGroupCompaniesLoading}
								value={selectedGroupCompanyId}
								onChange={handleGroupCompanyChange}
								options={groupCompanies}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isRelationTypesLoading)}
								optionFilterProp="label"
								placeholder="Relation Type"
								loading={isRelationTypesLoading}
								value={selectedRelationTypeId}
								onChange={handleRelationTypeChange}
								options={relationTypes}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isCompaniesLoading)}
								optionFilterProp="label"
								placeholder="Company Name"
								loading={isCompaniesLoading}
								value={selectedCompanyId}
								onChange={handleCompanyChange}
								options={companies}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isCountriesLoading)}
								optionFilterProp="label"
								placeholder="Country"
								loading={isCountriesLoading}
								value={selectedCountryId}
								onChange={handleCountryChange}
								options={countries}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isStatesLoading)}
								optionFilterProp="label"
								placeholder="State"
								loading={isStatesLoading}
								disabled={!selectedCountryId.length}
								value={selectedStateId}
								onChange={handleStateChange}
								options={states}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isDistrictCitiesLoading)}
								optionFilterProp="label"
								placeholder="District/City"
								loading={isDistrictCitiesLoading}
								disabled={!selectedStateId.length}
								value={selectedDistrictCityId}
								onChange={handleDistrictCityChange}
								options={districtCities}
							/>
							<Select
								mode="multiple"
								allowClear
								showSearch
								showArrow
								suffixIcon={getKycDropdownSuffixIcon(isLocationsLoading)}
								optionFilterProp="label"
								placeholder="Select Location"
								loading={isLocationsLoading}
								value={selectedLocationId}
								onChange={handleLocationChange}
								options={locations}
							/>
							<Button
								className="kyc-map-apply-btn"
								loading={isMapLocationsLoading}
								disabled={!hasSelectedMapFilters}
								onClick={handleApplyFilters}>
								Apply
							</Button>
							<Button
								className="kyc-map-reset-btn"
								disabled={!hasSelectedMapFilters && !mapMarkers.length}
								onClick={handleResetMapFilters}>
								Reset
							</Button>
						</div>
					</div>
				</div>
			</div>
			<Card className="kyc-map-card">
				<div
					ref={mapPanelRef}
					className={`kyc-map-layout${isMapInfoPanelVisible ? " has-info-panel" : " is-map-only"}${
						isMapFullscreen ? " is-fullscreen" : ""
					}`}>
					<div className="kyc-static-map">
						{googleMapLoadError || !googleMapsApiKey ? (
							<div className="kyc-map-missing-key">
								Google Maps could not be loaded. Check REACT_APP_GOOGLE_MAPS_API_KEY.
							</div>
						) : isGoogleMapLoaded ? (
							<GoogleMap
								mapContainerClassName="kyc-google-map"
								mapContainerStyle={{ width: "100%", height: "100%" }}
								center={DEFAULT_MAP_CENTER}
								zoom={DEFAULT_MAP_ZOOM}
								options={googleMapOptions}
								onLoad={setGoogleMap}
								onUnmount={() => setGoogleMap(null)}>
								{directionsResult && (
									<DirectionsRenderer
										directions={directionsResult}
										options={{
											suppressMarkers: true,
											preserveViewport: true,
											polylineOptions: {
												strokeColor: "#1890ff",
												strokeOpacity: 0.9,
												strokeWeight: 5,
											},
										}}
									/>
								)}
								{(() => {
									const fromLoc = extractLocation(fromPlace);
									return fromLoc.lat != null && fromLoc.lng != null ? (
										<Marker
											position={{ lat: fromLoc.lat, lng: fromLoc.lng }}
											title={fromInputValue || "From"}
											label={{ text: "A", color: "#fff", fontWeight: "700" }}
										/>
									) : null;
								})()}
								{(() => {
									const toLoc = extractLocation(toPlace);
									return toLoc.lat != null && toLoc.lng != null ? (
										<Marker
											position={{ lat: toLoc.lat, lng: toLoc.lng }}
											title={toInputValue || "To"}
											label={{ text: "B", color: "#fff", fontWeight: "700" }}
										/>
									) : null;
								})()}
								{(() => {
									// Optional waypoint marker (C) when Add Destination is selected
									if (!waypointPlace) return null;
									const waypointLoc = extractLocation(waypointPlace);
									return waypointLoc.lat != null && waypointLoc.lng != null ? (
										<Marker
											position={{ lat: waypointLoc.lat, lng: waypointLoc.lng }}
											title={waypointInputValue || "Waypoint"}
											label={{ text: "C", color: "#fff", fontWeight: "700" }}
										/>
									) : null;
								})()}
								{selectedMapMarker && (
									<InfoWindow
										position={selectedMapMarker.position}
										options={{
											maxWidth: 360,
											pixelOffset: window.google?.maps
												? new window.google.maps.Size(0, -36)
												: undefined,
										}}
										onCloseClick={closeMapMarkerInfo}>
										<div
											className="kyc-map-marker-info"
											onMouseEnter={handleInfoWindowMouseEnter}
											onMouseLeave={handleInfoWindowMouseLeave}>
											<div className="kyc-map-marker-info__hero">
												<img
													className="kyc-map-marker-info__logo"
													src={knackLogo}
													alt="Knack"
												/>
											</div>
											<div className="kyc-map-marker-info__content">
												<div className="kyc-map-marker-info__title">
													<img
														className="kyc-map-marker-info__icon kyc-map-marker-info__icon--location"
														src={getMapMarkerInfoIcon(selectedMapMarker.type)}
														alt=""
														aria-hidden
													/>
													<strong>{selectedMapMarker.title}</strong>
												</div>
												{selectedMapMarker.address ? (
													<p className="kyc-map-marker-info__address">
														{selectedMapMarker.address}
													</p>
												) : null}
												<div className="kyc-map-marker-info__codes">
													<p>
														<span>SAP Code:</span>{" "}
														{String(selectedMapMarker.sapCode || "").trim() || "-"}
													</p>
													<p>
														<span>Account Code:</span>{" "}
														{String(selectedMapMarker.accountCode || "").trim() || "-"}
													</p>
												</div>
												{(selectedMapMarker.phone || selectedMapMarker.email) && (
													<div className="kyc-map-marker-info__contacts">
														{selectedMapMarker.phone ? (
															<a href={`tel:${selectedMapMarker.phone}`}>
																<img
																	className="kyc-map-marker-info__icon"
																	src={infoWindowPhoneIcon}
																	alt=""
																	aria-hidden
																/>
																<span>{selectedMapMarker.phone}</span>
															</a>
														) : null}
														{selectedMapMarker.email ? (
															<a href={`mailto:${selectedMapMarker.email}`}>
																<img
																	className="kyc-map-marker-info__icon"
																	src={infoWindowMailIcon}
																	alt=""
																	aria-hidden
																/>
																<span>{selectedMapMarker.email}</span>
															</a>
														) : null}
													</div>
												)}
												<div className="kyc-map-marker-info__actions">
													<a
														className="kyc-map-marker-info__action kyc-map-marker-info__action--primary"
														href={`https://www.google.com/maps/dir/?api=1&destination=${selectedMapMarker.position.lat},${selectedMapMarker.position.lng}`}
														target="_blank"
														rel="noreferrer">
														Get Direction
														<img
															className="kyc-map-marker-info__action-icon"
															src={infoWindowChevronIcon}
															alt=""
															aria-hidden
														/>
													</a>
													<button
														type="button"
														className="kyc-map-marker-info__action kyc-map-marker-info__action--secondary"
														onClick={() =>
															handleMarkerClick(selectedMapMarker)
														}>
														View 10 Pillars
													</button>
												</div>
											</div>
										</div>
									</InfoWindow>
								)}
							</GoogleMap>
						) : (
							<div className="kyc-map-missing-key">Loading map...</div>
						)}
						{mapFullscreenControlNode
							? createPortal(mapFullscreenButton, mapFullscreenControlNode)
							: isGoogleMapLoaded
								? mapFullscreenButton
								: null}
						<div ref={selectFromLocationRef} className="kyc-map-select-location">
							{hasAppliedMapLocationSearch ? (
								<p className="kyc-map-locations-found">
									<strong>
										{formatMapLegendCount(mapLocationCounts.totalCount)}
									</strong>
									locations found
								</p>
							) : null}
							<div className="kyc-map-select-location__anchor">
								<button
									type="button"
									className={`kyc-map-select-location__trigger${isSelectFromLocationOpen ? " is-active" : ""
										}`}
									onClick={() => setIsSelectFromLocationOpen((open) => !open)}
									aria-expanded={isSelectFromLocationOpen}
									aria-controls="kyc-select-from-location-panel">
									Select From Location
									<img src={selectFromLocationIcon} alt="" aria-hidden />
								</button>
								<div
									id="kyc-select-from-location-panel"
									className={`kyc-map-select-location__panel${isSelectFromLocationOpen ? " is-open" : ""
										}`}
									role="dialog"
									aria-label="Select From Location"
									aria-hidden={!isSelectFromLocationOpen}>
									<h5 className="kyc-map-select-location__title">Select From Location</h5>
									<div className="kyc-map-select-location__route">
										<div className="kyc-map-select-location__stops">
											<div className="kyc-map-select-location__stop">
												<span
													className="kyc-map-select-location__location-icon"
													aria-hidden
												/>
												<div className="kyc-map-select-location__relation">
													{!selectFromLocationRelationTypeId.length ? (
														<span className="kyc-map-select-location__relation-placeholder">
															Relation Type
														</span>
													) : null}
													<Select
														className="kyc-map-select-location__relation-select"
														mode="multiple"
														allowClear
														showSearch
														showArrow
														virtual={false}
														suffixIcon={getKycDropdownSuffixIcon(
															isRelationTypesLoading
														)}
														optionFilterProp="label"
														placeholder=""
														loading={isRelationTypesLoading}
														value={
															selectFromLocationRelationTypeId.length
																? selectFromLocationRelationTypeId
																: undefined
														}
														onChange={(value) =>
															setSelectFromLocationRelationTypeId(
																value || []
															)
														}
														options={relationTypes}
														dropdownClassName="kyc-map-select-location__relation-dropdown"
														dropdownStyle={{ zIndex: 3000 }}
														dropdownMatchSelectWidth
														getPopupContainer={() => document.body}
													/>
												</div>
											</div>
											<div className="kyc-map-select-location__stop">
												<img
													className="kyc-map-select-location__location-icon"
													src={locationFromIcon}
													alt=""
													aria-hidden
												/>
												{isGoogleMapLoaded ? (
													<KycMapPlaceInput
														value={fromInputValue}
														placeholder="From location"
														onChange={(value) => {
															setFromInputValue(value);
															if (!value) setFromPlace(null);
														}}
														onPlaceSelected={handleFromPlaceSelected}
													/>
												) : (
													<Input
														className="kyc-map-select-location__input"
														value={fromInputValue}
														placeholder="From location"
														onChange={(event) =>
															setFromInputValue(event.target.value)
														}
													/>
												)}
											</div>
											<div className="kyc-map-select-location__stop">
												<img
													className="kyc-map-select-location__location-icon"
													src={locationToIcon}
													alt=""
													aria-hidden
												/>
												{isGoogleMapLoaded ? (
													<KycMapPlaceInput
														value={toInputValue}
														placeholder="To location"
														onChange={(value) => {
															setToInputValue(value);
															if (!value) setToPlace(null);
														}}
														onPlaceSelected={handleToPlaceSelected}
													/>
												) : (
													<Input
														className="kyc-map-select-location__input"
														value={toInputValue}
														placeholder="To location"
														onChange={(event) =>
															setToInputValue(event.target.value)
														}
													/>
												)}
											</div>
											<div className="kyc-map-select-location__stop">
												<img
													className="kyc-map-select-location__location-icon"
													src={addLocationIcon}
													alt=""
													aria-hidden
												/>
												{isGoogleMapLoaded ? (
													<KycMapPlaceInput
														value={waypointInputValue}
														placeholder="Add Destination"
														onChange={(value) => {
															setWaypointInputValue(value);
															if (!value) setWaypointPlace(null);
														}}
														onPlaceSelected={handleWaypointPlaceSelected}
													/>
												) : (
													<Input
														className="kyc-map-select-location__input"
														value={waypointInputValue}
														placeholder="Add Destination"
														onChange={(event) =>
															setWaypointInputValue(event.target.value)
														}
													/>
												)}
											</div>
										</div>
										<button
											type="button"
											className="kyc-map-select-location__swap"
											aria-label="Swap locations"
											title="Swap locations"
											onClick={handleSwapRouteLocations}>
											<img src={locationSwapIcon} alt="" aria-hidden />
										</button>
									</div>
									<div className="kyc-map-select-location__actions">
										<Button
											className="kyc-map-select-location__search"
											type="primary"
											loading={isRouteSearching || isMapLocationsLoading}
											disabled={
												!getPlaceGeometryLocation(fromPlace) ||
												!getPlaceGeometryLocation(toPlace)
											}
											onClick={handleRouteSearch}>
											Search
										</Button>
										<Button
											className="kyc-map-select-location__reset"
											disabled={
												!fromInputValue &&
												!toInputValue &&
												!waypointInputValue &&
												!selectFromLocationRelationTypeId.length &&
												!directionsResult &&
												!mapMarkers.length
											}
											onClick={handleResetSelectFromLocation}>
											Reset
										</Button>
									</div>
								</div>
							</div>
							{mapMarkers.length ? (
								<button
									type="button"
									className="kyc-map-multi-redirect-btn"
									onClick={handleOpenMultiRedirectModal}
									title="Open locations in Google Maps">
									<GlobalOutlined />
									<span>Open in Google Maps</span>
								</button>
							) : null}
						</div>
						{mapLegendControlNode
							? createPortal(
									<KycMapLegend
										showCounts={hasAppliedMapLocationSearch}
										locationCounts={mapLocationCounts}
									/>,
									mapLegendControlNode
							  )
							: (
								<KycMapLegend
									showCounts={hasAppliedMapLocationSearch}
									locationCounts={mapLocationCounts}
								/>
							)}
						<Modal
							className="kyc-multi-redirect-modal"
							title={
								<div className="kyc-multi-redirect-modal__title">
									<span className="kyc-multi-redirect-modal__title-icon">
										<GlobalOutlined />
									</span>
									<strong>Open in Google Maps</strong>
								</div>
							}
							visible={isMultiRedirectModalOpen}
							onCancel={handleCloseMultiRedirectModal}
							footer={null}
							destroyOnClose
							width={520}
							centered
							maskClosable={false}>
							<div className="kyc-multi-redirect-modal__body">
								<div className="kyc-multi-redirect-modal__note">
									<div className="kyc-multi-redirect-modal__note-label">Note</div>
									<p>
										You can open a maximum of {GOOGLE_MAPS_MULTI_REDIRECT_LIMIT}{" "}
										locations at a time.
									</p>
								</div>

								<div className="kyc-multi-redirect-modal__stats">
									<div className="kyc-multi-redirect-modal__stat">
										<span>Locations on map</span>
										<strong>{mapMarkers.length}</strong>
									</div>
									<div className="kyc-multi-redirect-modal__stat">
										<span>Redirect limit</span>
										<strong>{GOOGLE_MAPS_MULTI_REDIRECT_LIMIT}</strong>
									</div>
									{isMultiRedirectSelectMode ? (
										<div className="kyc-multi-redirect-modal__stat is-accent">
											<span>Selected</span>
											<strong>
												{selectedMultiRedirectIds.length}/
												{GOOGLE_MAPS_MULTI_REDIRECT_LIMIT}
											</strong>
										</div>
									) : null}
								</div>

								{!isMultiRedirectSelectMode ? (
									<div className="kyc-multi-redirect-modal__actions">
										<Button
											type="primary"
											className="kyc-multi-redirect-modal__primary"
											onClick={handleOpenFirstMultiRedirectMarkers}>
											Open Locations in Google Maps (First{" "}
											{GOOGLE_MAPS_MULTI_REDIRECT_LIMIT})
										</Button>
										<Button
											className="kyc-multi-redirect-modal__secondary"
											onClick={() => {
												setMultiRedirectSearchValue("");
												setIsMultiRedirectSelectMode(true);
											}}>
											Select locations (Max {GOOGLE_MAPS_MULTI_REDIRECT_LIMIT})
										</Button>
									</div>
								) : (
									<div className="kyc-multi-redirect-modal__select">
										<div className="kyc-multi-redirect-modal__select-header">
											<Button
												className="kyc-multi-redirect-modal__back"
												icon={<ArrowLeftOutlined />}
												onClick={() => {
													setIsMultiRedirectSelectMode(false);
													setSelectedMultiRedirectIds([]);
													setMultiRedirectSearchValue("");
												}}>
												Back
											</Button>
											<p>
												Choose up to {GOOGLE_MAPS_MULTI_REDIRECT_LIMIT} locations.
											</p>
											<Input
												className="kyc-multi-redirect-modal__search"
												prefix={<SearchOutlined />}
												placeholder="Search locations"
												allowClear
												value={multiRedirectSearchValue}
												onChange={(event) =>
													setMultiRedirectSearchValue(event.target.value)
												}
											/>
										</div>
										<div className="kyc-multi-redirect-modal__list-wrap">
											{filteredMultiRedirectMarkers.length ? (
												<KycMultiRedirectVirtualList
													items={filteredMultiRedirectMarkers}
													selectedIds={selectedMultiRedirectIds}
													limit={GOOGLE_MAPS_MULTI_REDIRECT_LIMIT}
													onToggle={handleToggleMultiRedirectMarker}
												/>
											) : (
												<div className="kyc-multi-redirect-modal__empty">
													No locations match your search.
												</div>
											)}
										</div>
										<div className="kyc-multi-redirect-modal__actions">
											<Button
												type="primary"
												className="kyc-multi-redirect-modal__primary"
												disabled={!selectedMultiRedirectIds.length}
												onClick={handleOpenSelectedMultiRedirectMarkers}>
												Open selected
												{selectedMultiRedirectIds.length
													? ` (${selectedMultiRedirectIds.length})`
													: ""}
											</Button>
										</div>
									</div>
								)}
							</div>
						</Modal>
					</div>
					{hasOpenedMapInfoPanel && !isMapInfoPanelVisible ? (
						<button
							type="button"
							className="kyc-map-panel-toggle kyc-map-panel-toggle--reopen"
							onClick={toggleMapInfoPanel}
							title="Show details panel"
							aria-label="Show details panel"
							aria-expanded="false">
							<LeftOutlined />
						</button>
					) : null}
					<aside
						className={`kyc-map-info${isMapInfoPanelVisible ? " is-open" : ""}`}
						aria-hidden={!isMapInfoPanelVisible}>
						<button
							type="button"
							className="kyc-map-panel-toggle"
							onClick={toggleMapInfoPanel}
							title="Hide details panel"
							aria-label="Hide details panel"
							aria-expanded={isMapInfoPanelVisible}
							tabIndex={isMapInfoPanelVisible ? 0 : -1}>
							<RightOutlined />
						</button>
						<div className="kyc-map-info__inner">
							{!isAccountSummaryLoading &&
							!selectedContactMarker &&
							!accountSummary ? (
								<div className="kyc-map-info__empty">
									Select a location on the map to see details.
								</div>
							) : isAccountSummaryLoading ? (
								<div className="kyc-map-info__loading">
									<Spin size="large" />
								</div>
							) : (
								(() => {
									const contactInfo = accountSummary?.contactInfo || null;
									const contactName =
										contactInfo?.name ||
										selectedContactMarker?.title ||
										"Company Name";
									const contactAddress =
										buildContactAddress(contactInfo) ||
										selectedContactMarker?.address ||
										"";
									const contactPhone =
										contactInfo?.mobilePhone || selectedContactMarker?.phone || "";
									const contactEmail =
										contactInfo?.email || selectedContactMarker?.email || "";
									const contactPerson =
										contactInfo?.primaryContactName ||
										selectedContactMarker?.primaryContactName ||
										"";
									const totalSummary = accountSummary?.summary || {};
									const totalSummaryRows = buildTotalSummaryRows(totalSummary);
									const outstandingAmount = formatOutstandingAmount(
										outstandingAmountLcy
									);
									const groupedAccounts = getGroupedAccountInfo(
										accountSummary?.accountInfo
									);
									const isGroupCompany =
										String(contactInfo?.entityType || "").toLowerCase() ===
										"groupcompany" ||
										selectedContactMarker?.type === "group";
									const contactPinType =
										selectedContactMarker?.type ||
										normalizeMapMarkerType(contactInfo?.entityType);
									const companyYearSummaries = groupedAccounts.flatMap(
										(account) => account.yearSummaries
									);
									const hasContactDetails =
										Boolean(contactAddress) ||
										Boolean(contactPhone) ||
										Boolean(contactEmail) ||
										Boolean(contactPerson);

									return (
										<>
											<div className="kyc-map-info__sticky-header">
												<h4>Contact Information</h4>
												<div className="kyc-contact-heading">
													<img src={getMapMarkerInfoIcon(contactPinType)} alt="" aria-hidden />
													<strong>{contactName}</strong>
												</div>
												{contactAddress ? (
													<p className="kyc-map-info__address">{contactAddress}</p>
												) : null}
												{contactPerson ? (
													<p className="kyc-map-info__meta">
														Primary Contact - {contactPerson}
													</p>
												) : null}
												{(contactPhone || contactEmail) && (
													<div className="kyc-map-info__contacts">
														{contactPhone ? (
															<a href={`tel:${contactPhone}`}>
																<img
																	src={infoWindowPhoneIcon}
																	alt=""
																	aria-hidden
																/>
																<span>{contactPhone}</span>
															</a>
														) : null}
														{contactEmail ? (
															<a href={`mailto:${contactEmail}`}>
																<img
																	src={infoWindowMailIcon}
																	alt=""
																	aria-hidden
																/>
																<span>{contactEmail}</span>
															</a>
														) : null}
													</div>
												)}
												{!hasContactDetails ? (
													<p className="kyc-map-info__meta">
														No contact details available for this location.
													</p>
												) : null}
											</div>

											<div className="kyc-map-info__scroll">
												{isGroupCompany && groupedAccounts.length ? (
													<>
														<h4 className="kyc-map-info__section-title">
															Account Information
														</h4>
														<div className="kyc-account-group-list">
															{groupedAccounts.map((account) => (
																<section
																	className="kyc-account-group"
																	key={account.key}>
																	<div className="kyc-account-group__header">
																		<div className="kyc-contact-heading">
																			<img
																				src={infoWindowLocationIcon}
																				alt=""
																				aria-hidden
																			/>
																			<strong>{account.customerName}</strong>
																		</div>
																		{account.address ? (
																			<p className="kyc-map-info__address">
																				{account.address}
																			</p>
																		) : null}
																		{account.primaryContactName ? (
																			<p className="kyc-map-info__meta">
																				Primary Contact -{" "}
																				{account.primaryContactName}
																			</p>
																		) : null}
																		{(account.phone || account.email) && (
																			<div className="kyc-map-info__contacts">
																				{account.phone ? (
																					<a href={`tel:${account.phone}`}>
																						<img
																							src={infoWindowPhoneIcon}
																							alt=""
																							aria-hidden
																						/>
																						<span>{account.phone}</span>
																					</a>
																				) : null}
																				{account.email ? (
																					<a href={`mailto:${account.email}`}>
																						<img
																							src={infoWindowMailIcon}
																							alt=""
																							aria-hidden
																						/>
																						<span>{account.email}</span>
																					</a>
																				) : null}
																			</div>
																		)}
																	</div>

																	{account.yearSummaries.length ? (
																		<div className="kyc-account-year-list">
																			{account.yearSummaries.map((summary) => (
																				<div
																					className="kyc-account-year-card"
																					key={summary.key}>
																					<div className="kyc-account-year-grid">
																						{buildAccountYearCardFields(
																							summary
																						).map((field) => (
																							<div
																								className={`kyc-account-year-cell${field.fullWidth
																										? " is-full"
																										: ""
																									}`}
																								key={`${summary.key}-${field.label}`}>
																								<span>{field.label}</span>
																								<p>{field.value}</p>
																							</div>
																						))}
																					</div>
																				</div>
																			))}
																		</div>
																	) : (
																		<p className="kyc-map-info__meta">
																			No yearly account summary available.
																		</p>
																	)}
																</section>
															))}
														</div>
													</>
												) : null}

												{!isGroupCompany && companyYearSummaries.length ? (
													<>
														<h4 className="kyc-map-info__section-title">
															Account Information
														</h4>
														<div className="kyc-account-year-list">
															{companyYearSummaries.map((summary) => (
																<div
																	className="kyc-account-year-card"
																	key={summary.key}>
																	<div className="kyc-account-year-grid">
																		{buildAccountYearCardFields(summary).map(
																			(field) => (
																				<div
																					className={`kyc-account-year-cell${field.fullWidth ? " is-full" : ""
																						}`}
																					key={`${summary.key}-${field.label}`}>
																					<span>{field.label}</span>
																					<p>{field.value}</p>
																				</div>
																			)
																		)}
																	</div>
																</div>
															))}
														</div>
													</>
												) : null}

												<h4 className="kyc-map-info__section-title mt-3">
													Total Summary
												</h4>
												<div className="kyc-total-summary-card">
													{totalSummaryRows.map((row) => (
														<div
															className="kyc-total-summary-row"
															key={row.label}>
															<span>{row.label}</span>
															<strong>{row.value}</strong>
														</div>
													))}
													<hr />
													<div className="kyc-outstanding-amount">
														<span>Total Outstanding Amount</span>
														<strong>{outstandingAmount}</strong>
													</div>
												</div>
											</div>
										</>
									);
								})()
							)}
						</div>
					</aside>
				</div>
				<div className="kyc-map-cluster-note">
					<div
						className="kyc-map-cluster-note__legend"
						aria-label="Cluster color explanation">
						<span className="kyc-map-cluster-note__item">
							<span className="kyc-map-cluster-note__dot is-blue" aria-hidden />
							Blue cluster = normal density
						</span>
						<span className="kyc-map-cluster-note__divider" aria-hidden>
							|
						</span>
						<span className="kyc-map-cluster-note__item">
							<span className="kyc-map-cluster-note__dot is-red" aria-hidden />
							Red cluster = higher-than-average marker count
						</span>
					</div>
					{hasAppliedMapLocationSearch ? (
						<span className="kyc-map-cluster-note__view">
							<span className="kyc-map-cluster-note__view-icon" aria-hidden />
							In current view:{" "}
							<strong>
								{formatMapLegendCount(mapViewportMarkerCount)} of{" "}
								{formatMapLegendCount(mapMarkers.length)}
							</strong>
						</span>
					) : null}
				</div>
			</Card>
		</Fragment>
	);
};

export default KycDashboard;
